/*
# -----------------------------------------------------------------------------
# Component: riskAccumAjaxMixin.js
# Author: ssy@pst.sg
# Created Date: 06/September/2019
# Comments: Responsible for all backend related calls for RI Header
# -----------------------------------------------------------------------------
*/
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'
import { formatPrice } from '@/utils/index'
import { removeFormatNumber } from '@/utils/number'
import { extractMenu } from '@/utils/extract'
import { formatYesNo } from '@/utils/boolean'

export const riskAccumAjaxMixin = {
  data() {
    return {
      actionType: undefined
    }
  },
  computed: {
    riskAccumulationList() {
      return this.$store.state.riskAccumulation.riskAccumulationList.menu
    }
  },
  methods: {
    async fetchData() {
      const apiUrl = this.$store.state.riskAccumulation.riskAccumulationList.getAccumTypeLists
      if (apiUrl) {
        return apiUrl
      }
    },
    async setReportMenu() {
      try {
        if (this.$store.state.reports.uwReports.menu !== 1) {
          await Promise.all([this.$store.dispatch('uwReportsInit')])
        }
        const apiURI = this.riskAccumulationList.initBlkRegister
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    async riskAccumBlkGrpInit() {
      const apiUrl = this.riskAccumulationList.getBlkGrpLists
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationBlkGrp
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          const params = {
            accmType: this.riskAccumForm.accumType,
            blkGrp: this.filters.blkGrp,
            blkGrpDescS: this.filters.blkGrpDescS
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), params, this.paginationBlkGrp.sortBy, this.paginationBlkGrp.descending))
          if (result.data) {
            this.totalItemsBlkGrp = result.data.totalElements
            const { data } = result.data
            this.blkGrpItems = []
            if (data) {
              data.map(blkGrp => {
                const convertBlkGrp = {
                  accmType: blkGrp.accmType,
                  blkGrp: blkGrp.blkGrp,
                  blkGrpDescS: blkGrp.blkGrpDescS,
                  blkGrpDescL: blkGrp.blkGrpDescL
                }
                // if (convertBlkGrp.blkGrp !== '' && convertBlkGrp.blkGrp !== undefined) {
                this.blkGrpItems.push(convertBlkGrp)
                // }
              })
            } else {
              this.blkGrpItems = []
            }
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
        }
      }
    },
    async riskAccumBlkGrpTransferInit() {
      const apiUrl = this.riskAccumulationList.getBlkGrpLists
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationBlkGrp
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          const params = {
            accmType: this.transferForm.accumType,
            blkGrp: this.filters.blkGrp,
            blkGrpDescS: this.filters.blkGrpDescS
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), params, this.paginationBlkGrp.sortBy, this.paginationBlkGrp.descending))
          if (result.data) {
            this.totalItemsBlkGrp = result.data.totalElements
            const { data } = result.data
            this.blkGrpItems = []
            if (data) {
              data.map(blkGrp => {
                const convertBlkGrp = {
                  accmType: blkGrp.accmType,
                  blkGrp: blkGrp.blkGrp,
                  blkGrpDescS: blkGrp.blkGrpDescS,
                  blkGrpDescL: blkGrp.blkGrpDescL
                }
                // if (convertBlkGrp.blkGrp !== '' && convertBlkGrp.blkGrp !== undefined) {
                this.blkGrpItems.push(convertBlkGrp)
                // }
              })
            } else {
              this.blkGrpItems = []
            }
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
        }
      }
    },
    async riskAccumBlkGrpExtraBlkInit() {
      const apiUrl = this.riskAccumulationList.getBlkGrpLists
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationBlkGrp
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          const params = {
            accmType: this.extraBlkForm.accmType,
            blkGrp: this.filters.blkGrp,
            blkGrpDescS: this.filters.blkGrpDescS
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), params, this.paginationBlkGrp.sortBy, this.paginationBlkGrp.descending))
          if (result.data) {
            this.totalItemsBlkGrp = result.data.totalElements
            const { data } = result.data
            this.blkGrpItems = []
            if (data) {
              data.map(blkGrp => {
                const convertBlkGrp = {
                  accmType: blkGrp.accmType,
                  blkGrp: blkGrp.blkGrp,
                  blkGrpDescS: blkGrp.blkGrpDescS,
                  blkGrpDescL: blkGrp.blkGrpDescL
                }
                // if (convertBlkGrp.blkGrp !== '' && convertBlkGrp.blkGrp !== undefined) {
                this.blkGrpItems.push(convertBlkGrp)
                // }
              })
            } else {
              this.blkGrpItems = []
            }
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
        }
      }
    },
    async doSelectBlkGrp(blkGrp) {
      if (this.transferAll) {
        if (this.transferForm.transferType === 'transferFrom') {
          if (this.transferForm.accumType !== undefined) {
            const oriBlkGrpLblS = this.transferForm.blkGrpLblSFrom
            this.transferForm.blkGrpLblSFrom = blkGrp.blkGrp
            this.transferForm.blkGrpLblLFrom = blkGrp.blkGrpDescL

            if (this.transferForm.blksGrp1LblS !== undefined && this.transferForm.blkGrpLblS !== oriBlkGrpLblS) {
              this.transferForm.blksGrp1LblSFrom = undefined
              this.transferForm.blksGrp1LblLFrom = undefined
            }
            if (this.transferForm.blksGrp2LblS !== undefined && this.transferForm.blkGrpLblS !== oriBlkGrpLblS) {
              this.transferForm.blksGrp2LblSFrom = undefined
              this.transferForm.blksGrp2LblLFrom = undefined
            }
            if (this.transferForm.blksLblS !== undefined && this.transferForm.blkGrpLblS !== oriBlkGrpLblS) {
              this.transferForm.blksLblSFrom = undefined
              this.transferForm.blksLblLFrom = undefined
            }
            this.riskAccumBlkGrpDialog = false
          } else {
            this.transferForm.blkGrpLblSFrom = undefined
            this.transferForm.blkGrpLblLFrom = undefined
            this.riskAccumBlkGrpDialog = false
          }
        } else if (this.transferForm.transferType === 'transferTo') {
          if (this.transferForm.accumType !== undefined) {
            const oriBlkGrpLblSTo = this.transferForm.blkGrpLblSTo
            this.transferForm.blkGrpLblSTo = blkGrp.blkGrp
            this.transferForm.blkGrpLblLTo = blkGrp.blkGrpDescL

            if (this.transferForm.blksGrp1LblS !== undefined && this.transferForm.blkGrpLblS !== oriBlkGrpLblSTo) {
              this.transferForm.blksGrp1LblSTo = undefined
              this.transferForm.blksGrp1LblLTo = undefined
            }
            if (this.transferForm.blksGrp2LblS !== undefined && this.transferForm.blkGrpLblS !== oriBlkGrpLblSTo) {
              this.transferForm.blksGrp2LblSTo = undefined
              this.transferForm.blksGrp2LblLTo = undefined
            }
            if (this.transferForm.blksLblS !== undefined && this.transferForm.blkGrpLblS !== oriBlkGrpLblSTo) {
              this.transferForm.blksLblSTo = undefined
              this.transferForm.blksLblLTo = undefined
            }
            this.riskAccumBlkGrpDialog = false
          } else {
            this.transferForm.blkGrpLblSTo = undefined
            this.transferForm.blkGrpLblLTo = undefined
            this.riskAccumBlkGrpDialog = false
          }
        }
      } else if (this.showExtraBlk) {
        if (this.extraBlkForm.accumType !== undefined) {
          const oriBlkGrpLblS = this.extraBlkForm.blkGrpLblS
          this.extraBlkForm.blkGrpLblS = blkGrp.blkGrp
          this.extraBlkForm.blkGrpLblL = blkGrp.blkGrpDescL

          if (this.extraBlkForm.blksGrp1LblS !== undefined && this.extraBlkForm.blkGrpLblS !== oriBlkGrpLblS) {
            this.extraBlkForm.blksGrp1LblS = undefined
            this.extraBlkForm.blksGrp1LblL = undefined
          }
          if (this.extraBlkForm.blksGrp2LblS !== undefined && this.extraBlkForm.blkGrpLblS !== oriBlkGrpLblS) {
            this.extraBlkForm.blksGrp2LblS = undefined
            this.extraBlkForm.blksGrp2LblL = undefined
          }
          if (this.extraBlkForm.blksLblS !== undefined && this.extraBlkForm.blkGrpLblS !== oriBlkGrpLblS) {
            this.extraBlkForm.blksLblS = undefined
            this.extraBlkForm.blksLblL = undefined
          }
          this.riskAccumBlkGrpDialog = false
        } else {
          this.extraBlkForm.blkGrpLblS = undefined
          this.extraBlkForm.blkGrpLblL = undefined
          this.riskAccumBlkGrpDialog = false
        }
      } else {
        if (this.riskAccumForm.accumType !== undefined) {
          const oriBlkGrpLblS = this.riskAccumForm.blkGrpLblS
          this.riskAccumForm.blkGrpLblS = blkGrp.blkGrp
          this.riskAccumForm.blkGrpLblL = blkGrp.blkGrpDescL

          // 2020-10-22 LYT OS-534
          if (this.riskAccumForm.blksGrp1LblS !== undefined && this.riskAccumForm.blkGrpLblS !== oriBlkGrpLblS) {
            this.riskAccumForm.blksGrp1LblS = undefined
            this.riskAccumForm.blksGrp1LblL = undefined
          }
          if (this.riskAccumForm.blksGrp2LblS !== undefined && this.riskAccumForm.blkGrpLblS !== oriBlkGrpLblS) {
            this.riskAccumForm.blksGrp2LblS = undefined
            this.riskAccumForm.blksGrp2LblL = undefined
          }
          if (this.riskAccumForm.blksLblS !== undefined && this.riskAccumForm.blkGrpLblS !== oriBlkGrpLblS) {
            this.riskAccumForm.blksLblS = undefined
            this.riskAccumForm.blksLblL = undefined
          }

          this.riskAccumBlkGrpDialog = false
        } else {
          this.riskAccumForm.blkGrpLblS = undefined
          this.riskAccumForm.blkGrpLblL = undefined
          this.riskAccumBlkGrpDialog = false
        }
      }
    },
    async riskAccumBlkSubGrp1Init() {
      const apiUrl = this.riskAccumulationList.getBlkSubGrp1List
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationBlkSubGrp1
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          const params = {
            accmType: this.riskAccumForm.accumType,
            blkGrp: this.riskAccumForm.blkGrpLblS,
            blksGrp1: this.filters.blkSubGrp1,
            blksGrp1descS: this.filters.blkSubGrp1DescS
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), params, this.paginationBlkSubGrp1.sortBy, this.paginationBlkSubGrp1.descending))
          if (result.data) {
            this.totalItemsBlkSubGrp1 = result.data.totalElements
            const { data } = result.data
            this.blkSubGrp1Items = []
            if (data) {
              data.map(blkSubGrp1 => {
                const convertBlkSubGrp1 = {
                  accmType: blkSubGrp1.accmType,
                  blkSubGrp1: blkSubGrp1.blksGrp1,
                  blkSubGrp1DescS: blkSubGrp1.blksGrp1DescS
                }
                this.blkSubGrp1Items.push(convertBlkSubGrp1)
              })
            } else {
              this.blkSubGrp1Items = []
            }
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
        }
      }
    },
    async riskAccumBlkSubGrp1TransferInit() {
      const apiUrl = this.riskAccumulationList.getBlkSubGrp1List
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationBlkSubGrp1
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          if (this.transferForm.transferType === 'transferFrom') {
            const params = {
              accmType: this.transferForm.accumType,
              blkGrp: this.transferForm.blkGrpLblSFrom,
              blksGrp1: this.filters.blkSubGrp1,
              blksGrp1descS: this.filters.blkSubGrp1DescS
            }
            const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), params, this.paginationBlkSubGrp1.sortBy, this.paginationBlkSubGrp1.descending))
            if (result.data) {
              this.totalItemsBlkSubGrp1 = result.data.totalElements
              const { data } = result.data
              this.blkSubGrp1Items = []
              if (data) {
                data.map(blkSubGrp1 => {
                  const convertBlkSubGrp1 = {
                    accmType: blkSubGrp1.accmType,
                    blkSubGrp1: blkSubGrp1.blksGrp1,
                    blkSubGrp1DescS: blkSubGrp1.blksGrp1DescS
                  }
                  this.blkSubGrp1Items.push(convertBlkSubGrp1)
                })
              } else {
                this.blkSubGrp1Items = []
              }
              this.loading = false
            }
          } else if (this.transferForm.transferType === 'transferTo') {
            const params = {
              accmType: this.transferForm.accumType,
              blkGrp: this.transferForm.blkGrpLblSTo,
              blksGrp1: this.filters.blkSubGrp1,
              blksGrp1descS: this.filters.blkSubGrp1DescS
            }
            const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), params, this.paginationBlkSubGrp1.sortBy, this.paginationBlkSubGrp1.descending))
            if (result.data) {
              this.totalItemsBlkSubGrp1 = result.data.totalElements
              const { data } = result.data
              this.blkSubGrp1Items = []
              if (data) {
                data.map(blkSubGrp1 => {
                  const convertBlkSubGrp1 = {
                    accmType: blkSubGrp1.accmType,
                    blkSubGrp1: blkSubGrp1.blksGrp1,
                    blkSubGrp1DescS: blkSubGrp1.blksGrp1DescS
                  }
                  this.blkSubGrp1Items.push(convertBlkSubGrp1)
                })
              } else {
                this.blkSubGrp1Items = []
              }
              this.loading = false
            }
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
        }
      }
    },
    async riskAccumBlkSubGrp1ExtraBlkInit() {
      const apiUrl = this.riskAccumulationList.getBlkSubGrp1List
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationBlkSubGrp1
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          const params = {
            accmType: this.extraBlkForm.accmType,
            blkGrp: this.extraBlkForm.blkGrpLblS,
            blksGrp1: this.filters.blkSubGrp1,
            blksGrp1descS: this.filters.blkSubGrp1DescS
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), params, this.paginationBlkSubGrp1.sortBy, this.paginationBlkSubGrp1.descending))
          if (result.data) {
            this.totalItemsBlkSubGrp1 = result.data.totalElements
            const { data } = result.data
            this.blkSubGrp1Items = []
            if (data) {
              data.map(blkSubGrp1 => {
                const convertBlkSubGrp1 = {
                  accmType: blkSubGrp1.accmType,
                  blkSubGrp1: blkSubGrp1.blksGrp1,
                  blkSubGrp1DescS: blkSubGrp1.blksGrp1DescS
                }
                this.blkSubGrp1Items.push(convertBlkSubGrp1)
              })
            } else {
              this.blkSubGrp1Items = []
            }
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
        }
      }
    },
    async doSelectBlkSubGrp1(blkSubGrp1) {
      if (this.transferAll) {
        if (this.transferForm.transferType === 'transferFrom') {
          if (this.transferForm.accumType !== undefined && this.transferForm.blkGrpLblSFrom !== undefined) {
            const oriBlksGrp1LblS = this.transferForm.blksGrp1LblSFrom
            this.transferForm.blksGrp1LblSFrom = blkSubGrp1.blkSubGrp1
            this.transferForm.blksGrp1LblLFrom = blkSubGrp1.blkSubGrp1DescS

            if (this.transferForm.blksGrp2LblSFrom !== undefined && this.transferForm.blksGrp1LblSFrom !== oriBlksGrp1LblS) {
              this.transferForm.blksGrp2LblSFrom = undefined
              this.transferForm.blksGrp2LblLFrom = undefined
            }
            if (this.transferForm.blksLblSFrom !== undefined && this.transferForm.blksGrp1LblSFrom !== oriBlksGrp1LblS) {
              this.transferForm.blksLblSFrom = undefined
              this.transferForm.blksLblLFrom = undefined
            }
            this.riskAccumBlkSubGrp1Dialog = false
          }
        } else if (this.transferForm.transferType === 'transferTo') {
          if (this.transferForm.accumType !== undefined && this.transferForm.blkGrpLblSTo !== undefined) {
            const oriBlksGrp1LblS = this.transferForm.blksGrp1LblSTo
            this.transferForm.blksGrp1LblSTo = blkSubGrp1.blkSubGrp1
            this.transferForm.blksGrp1LblLTo = blkSubGrp1.blkSubGrp1DescS

            if (this.transferForm.blksGrp2LblS !== undefined && this.transferForm.blksGrp1LblS !== oriBlksGrp1LblS) {
              this.transferForm.blksGrp2LblS = undefined
              this.transferForm.blksGrp2LblL = undefined
            }
            if (this.transferForm.blksLblS !== undefined && this.transferForm.blksGrp1LblS !== oriBlksGrp1LblS) {
              this.transferForm.blksLblS = undefined
              this.transferForm.blksLblL = undefined
            }
            this.riskAccumBlkSubGrp1Dialog = false
          }
        }
      } else if (this.showExtraBlk) {
        if (this.extraBlkForm.accumType !== undefined && this.extraBlkForm.blkGrpLblS !== undefined) {
          const oriBlksGrp1LblS = this.extraBlkForm.blksGrp1LblS
          this.extraBlkForm.blksGrp1LblS = blkSubGrp1.blkSubGrp1
          this.extraBlkForm.blksGrp1LblL = blkSubGrp1.blkSubGrp1DescS

          if (this.extraBlkForm.blksGrp2LblS !== undefined && this.extraBlkForm.blksGrp1LblS !== oriBlksGrp1LblS) {
            this.extraBlkForm.blksGrp2LblS = undefined
            this.extraBlkForm.blksGrp2LblL = undefined
          }
          if (this.extraBlkForm.blksLblS !== undefined && this.extraBlkForm.blksGrp1LblS !== oriBlksGrp1LblS) {
            this.extraBlkForm.blksLblS = undefined
            this.extraBlkForm.blksLblL = undefined
          }
          this.riskAccumBlkSubGrp1Dialog = false
        }
      } else {
        if (this.riskAccumForm.accumType !== undefined && this.riskAccumForm.blkGrpLblS !== undefined) {
          const oriBlksGrp1LblS = this.riskAccumForm.blksGrp1LblS
          this.riskAccumForm.blksGrp1LblS = blkSubGrp1.blkSubGrp1
          this.riskAccumForm.blksGrp1LblL = blkSubGrp1.blkSubGrp1DescS

          // 2020-10-22 LYT OS-534
          if (this.riskAccumForm.blksGrp2LblS !== undefined && this.riskAccumForm.blksGrp1LblS !== oriBlksGrp1LblS) {
            this.riskAccumForm.blksGrp2LblS = undefined
            this.riskAccumForm.blksGrp2LblL = undefined
          }
          if (this.riskAccumForm.blksLblS !== undefined && this.riskAccumForm.blksGrp1LblS !== oriBlksGrp1LblS) {
            this.riskAccumForm.blksLblS = undefined
            this.riskAccumForm.blksLblL = undefined
          }
          this.riskAccumBlkSubGrp1Dialog = false
        }
      }
    },
    async riskAccumBlkSubGrp2Init() {
      const apiUrl = this.riskAccumulationList.getBlkSubGrp2List
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationBlkSubGrp2
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          const params = {
            accmType: this.riskAccumForm.accumType,
            blkGrp: this.riskAccumForm.blkGrpLblS,
            blkSubGrp1: this.riskAccumForm.blksGrp1LblS,
            blksGrp2: this.filters.blkSubGrp2,
            blksGrp2descS: this.filters.blkSubGrp2DescS
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), params, this.paginationBlkSubGrp2.sortBy, this.paginationBlkSubGrp2.descending))
          if (result.data) {
            this.totalItemsBlkSubGrp2 = result.data.totalElements
            const { data } = result.data
            this.blkSubGrp2Items = []
            if (data) {
              data.map(blkSubGrp2 => {
                const convertBlkSubGrp2 = {
                  accmType: blkSubGrp2.accmType,
                  blkSubGrp2: blkSubGrp2.blksGrp2,
                  blkSubGrp2DescS: blkSubGrp2.blksGrp2DescS
                }
                this.blkSubGrp2Items.push(convertBlkSubGrp2)
              })
            } else {
              this.blkSubGrp2Items = []
            }
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
        }
      }
    },
    async riskAccumBlkSubGrp2TransferInit() {
      const apiUrl = this.riskAccumulationList.getBlkSubGrp2List
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationBlkSubGrp2
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          if (this.transferForm.transferType === 'transferForm') {
            const params = {
              accmType: this.riskAccumForm.accumType,
              blkGrp: this.riskAccumForm.blkGrpLblSFrom,
              blkSubGrp1: this.riskAccumForm.blksGrp1LblSFrom,
              blksGrp2: this.filters.blkSubGrp2,
              blksGrp2descS: this.filters.blkSubGrp2DescS
            }
            const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), params, this.paginationBlkSubGrp2.sortBy, this.paginationBlkSubGrp2.descending))
            if (result.data) {
              this.totalItemsBlkSubGrp2 = result.data.totalElements
              const { data } = result.data
              this.blkSubGrp2Items = []
              if (data) {
                data.map(blkSubGrp2 => {
                  const convertBlkSubGrp2 = {
                    accmType: blkSubGrp2.accmType,
                    blkSubGrp2: blkSubGrp2.blksGrp2,
                    blkSubGrp2DescS: blkSubGrp2.blksGrp2DescS
                  }
                  this.blkSubGrp2Items.push(convertBlkSubGrp2)
                })
              } else {
                this.blkSubGrp2Items = []
              }
              this.loading = false
            }
          } else if (this.transferForm.transferType === 'transferTo') {
            const params = {
              accmType: this.riskAccumForm.accumType,
              blkGrp: this.riskAccumForm.blkGrpLblSTo,
              blkSubGrp1: this.riskAccumForm.blksGrp1LblSTo,
              blksGrp2: this.filters.blkSubGrp2,
              blksGrp2descS: this.filters.blkSubGrp2DescS
            }
            const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), params, this.paginationBlkSubGrp2.sortBy, this.paginationBlkSubGrp2.descending))
            if (result.data) {
              this.totalItemsBlkSubGrp2 = result.data.totalElements
              const { data } = result.data
              this.blkSubGrp2Items = []
              if (data) {
                data.map(blkSubGrp2 => {
                  const convertBlkSubGrp2 = {
                    accmType: blkSubGrp2.accmType,
                    blkSubGrp2: blkSubGrp2.blksGrp2,
                    blkSubGrp2DescS: blkSubGrp2.blksGrp2DescS
                  }
                  this.blkSubGrp2Items.push(convertBlkSubGrp2)
                })
              } else {
                this.blkSubGrp2Items = []
              }
              this.loading = false
            }
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
        }
      }
    },
    async riskAccumBlkSubGrp2ExtraBlkInit() {
      const apiUrl = this.riskAccumulationList.getBlkSubGrp2List
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationBlkSubGrp2
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          const params = {
            accmType: this.extraBlkForm.accmType,
            blkGrp: this.extraBlkForm.blkGrpLblS,
            blkSubGrp1: this.extraBlkForm.blksGrp1LblS,
            blksGrp2: this.filters.blkSubGrp2,
            blksGrp2descS: this.filters.blkSubGrp2DescS
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), params, this.paginationBlkSubGrp2.sortBy, this.paginationBlkSubGrp2.descending))
          if (result.data) {
            this.totalItemsBlkSubGrp2 = result.data.totalElements
            const { data } = result.data
            this.blkSubGrp2Items = []
            if (data) {
              data.map(blkSubGrp2 => {
                const convertBlkSubGrp2 = {
                  accmType: blkSubGrp2.accmType,
                  blkSubGrp2: blkSubGrp2.blksGrp2,
                  blkSubGrp2DescS: blkSubGrp2.blksGrp2DescS
                }
                this.blkSubGrp2Items.push(convertBlkSubGrp2)
              })
            } else {
              this.blkSubGrp2Items = []
            }
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
        }
      }
    },
    async doSelectBlkSubGrp2(blkSubGrp2) {
      if (this.transferAll) {
        if (this.transferForm.transferType === 'transferFrom') {
          if (this.transferForm.accumType !== undefined && this.transferForm.blkGrpLblSFrom !== undefined) {
            const oriBlksGrp2LblS = this.transferForm.blksGrp2LblSFrom
            this.transferForm.blksGrp2LblSFrom = blkSubGrp2.blkSubGrp2
            this.transferForm.blksGrp2LblLFrom = blkSubGrp2.blkSubGrp2DescS

            // 2020-10-22 LYT OS-534
            if (this.transferForm.blksLblSFrom !== undefined && this.transferForm.blksGrp2LblSFrom !== oriBlksGrp2LblS) {
              this.transferForm.blksLblSFrom = undefined
              this.transferForm.blksLblLFrom = undefined
            }

            this.riskAccumBlkSubGrp2Dialog = false
          }
        } else if (this.transferForm.transferType === 'transferTo') {
          if (this.transferForm.accumType !== undefined && this.transferForm.blkGrpLblSTo !== undefined) {
            const oriBlksGrp2LblS = this.transferForm.blksGrp2LblSTo
            this.transferForm.blksGrp2LblSTo = blkSubGrp2.blkSubGrp2
            this.transferForm.blksGrp2LblLTo = blkSubGrp2.blkSubGrp2DescS

            // 2020-10-22 LYT OS-534
            if (this.transferForm.blksLblSTo !== undefined && this.transferForm.blksGrp2LblSTo !== oriBlksGrp2LblS) {
              this.transferForm.blksLblSTo = undefined
              this.transferForm.blksLblLTo = undefined
            }

            this.riskAccumBlkSubGrp2Dialog = false
          }
        }
      } else if (this.showExtraBlk) {
        if (this.extraBlkForm.accmType !== undefined && this.extraBlkForm.blkGrpLblS !== undefined) {
          const oriBlksGrp2LblS = this.extraBlkForm.blksGrp2LblS
          this.extraBlkForm.blksGrp2LblS = blkSubGrp2.blkSubGrp2
          this.extraBlkForm.blksGrp2LblL = blkSubGrp2.blkSubGrp2DescS

          if (this.extraBlkForm.blksLblS !== undefined && this.extraBlkForm.blksGrp2LblS !== oriBlksGrp2LblS) {
            this.extraBlkForm.blksLblS = undefined
            this.extraBlkForm.blksLblL = undefined
          }

          this.riskAccumBlkSubGrp2Dialog = false
        }
      } else {
        if (this.riskAccumForm.accumType !== undefined && this.riskAccumForm.blkGrpLblS !== undefined) {
          const oriBlksGrp2LblS = this.riskAccumForm.blksGrp2LblS
          this.riskAccumForm.blksGrp2LblS = blkSubGrp2.blkSubGrp2
          this.riskAccumForm.blksGrp2LblL = blkSubGrp2.blkSubGrp2DescS

          // 2020-10-22 LYT OS-534
          if (this.riskAccumForm.blksLblS !== undefined && this.riskAccumForm.blksGrp2LblS !== oriBlksGrp2LblS) {
            this.riskAccumForm.blksLblS = undefined
            this.riskAccumForm.blksLblL = undefined
          }

          this.riskAccumBlkSubGrp2Dialog = false
        }
      }
    },
    async riskAccumBlkInit() {
      const apiUrl = this.riskAccumulationList.getBlkList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationBlk
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          const params = {
            accmType: this.riskAccumForm.accumType,
            blkGrp: this.riskAccumForm.blkGrpLblS !== undefined ? this.riskAccumForm.blkGrpLblS : '',
            blksGrp1: this.riskAccumForm.blksGrp1LblS !== undefined ? this.riskAccumForm.blksGrp1LblS : '',
            blksGrp2: this.riskAccumForm.blksGrp2LblS !== undefined ? this.riskAccumForm.blksGrp2LblS : '',
            effDate: formatDisplayDate(this.riskAccumForm.effDate),
            blk: this.filters.blk,
            blkDesc: this.filters.blkDescS
          }

          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), params, this.paginationBlk.sortBy, this.paginationBlk.descending))
          if (result.data) {
            this.totalItemsBlk = result.data.totalElements
            const { data } = result.data
            this.blkItems = []
            if (data) {
              data.map(blk => {
                const convertBlk = {
                  accmType: blk.accmType,
                  blk: blk.blk,
                  blkGrp: blk.blkGrp,
                  blksGrp1: blk.blksGrp1,
                  blksGrp2: blk.blksGrp2,
                  blkDesc: blk.blkDesc,
                  inclNorm: blk.inclNorm,
                  ownLim: blk.ownLim,
                  ownRtn: blk.ownRtn
                }
                this.blkItems.push(convertBlk)
              })
            } else {
              this.blkItems = []
            }
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
        }
      }
    },
    async riskAccumBlkTransferInit() {
      const apiUrl = this.riskAccumulationList.getBlkList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationBlk
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          if (this.transferForm.transferType === 'transferFrom') {
            const params = {
              accmType: this.transferForm.accumType,
              blkGrp: this.transferForm.blkGrpLblSFrom !== undefined ? this.transferForm.blkGrpLblSFrom : '',
              blksGrp1: this.transferForm.blksGrp1LblSFrom !== undefined ? this.transferForm.blksGrp1LblSFrom : '',
              blksGrp2: this.transferForm.blksGrp2LblSFrom !== undefined ? this.transferForm.blksGrp2LblSFrom : '',
              blk: this.filters.blk,
              blkDesc: this.filters.blkDescS
            }

            const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), params, this.paginationBlk.sortBy, this.paginationBlk.descending))
            if (result.data) {
              this.totalItemsBlk = result.data.totalElements
              const { data } = result.data
              this.blkItems = []
              if (data) {
                data.map(blk => {
                  const convertBlk = {
                    accmType: blk.accmType,
                    blk: blk.blk,
                    blkGrp: blk.blkGrp,
                    blksGrp1: blk.blksGrp1,
                    blksGrp2: blk.blksGrp2,
                    blkDesc: blk.blkDesc,
                    inclNorm: blk.inclNorm,
                    ownLim: blk.ownLim,
                    ownRtn: blk.ownRtn
                  }
                  this.blkItems.push(convertBlk)
                })
              } else {
                this.blkItems = []
              }
              this.loading = false
            }
          } else if (this.transferForm.transferType === 'transferTo') {
            const params = {
              accmType: this.transferForm.accumType,
              blkGrp: this.transferForm.blkGrpLblSTo !== undefined ? this.transferForm.blkGrpLblSTo : '',
              blksGrp1: this.transferForm.blksGrp1LblSTo !== undefined ? this.transferForm.blksGrp1LblSTo : '',
              blksGrp2: this.transferForm.blksGrp2LblSTo !== undefined ? this.transferForm.blksGrp2LblSTo : '',
              blk: this.filters.blk,
              blkDesc: this.filters.blkDescS
            }

            const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), params, this.paginationBlk.sortBy, this.paginationBlk.descending))
            if (result.data) {
              this.totalItemsBlk = result.data.totalElements
              const { data } = result.data
              this.blkItems = []
              if (data) {
                data.map(blk => {
                  const convertBlk = {
                    accmType: blk.accmType,
                    blk: blk.blk,
                    blkGrp: blk.blkGrp,
                    blksGrp1: blk.blksGrp1,
                    blksGrp2: blk.blksGrp2,
                    blkDesc: blk.blkDesc,
                    inclNorm: blk.inclNorm,
                    ownLim: blk.ownLim,
                    ownRtn: blk.ownRtn
                  }
                  this.blkItems.push(convertBlk)
                })
              } else {
                this.blkItems = []
              }
              this.loading = false
            }
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
        }
      }
    },
    async riskAccumBlkExtraBlkInit() {
      const apiUrl = this.riskAccumulationList.getBlkList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationBlk
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          const params = {
            accmType: this.extraBlkForm.accumType,
            blkGrp: this.extraBlkForm.blkGrpLblS !== undefined ? this.extraBlkForm.blkGrpLblS : '',
            blksGrp1: this.extraBlkForm.blksGrp1LblS !== undefined ? this.extraBlkForm.blksGrp1LblS : '',
            blksGrp2: this.extraBlkForm.blksGrp2LblS !== undefined ? this.extraBlkForm.blksGrp2LblS : '',
            effDate: formatDisplayDate(this.extraBlkForm.effDate),
            blk: this.filters.blk,
            blkDesc: this.filters.blkDescS
          }

          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), params, this.paginationBlk.sortBy, this.paginationBlk.descending))
          if (result.data) {
            this.totalItemsBlk = result.data.totalElements
            const { data } = result.data
            this.blkItems = []
            if (data) {
              data.map(blk => {
                const convertBlk = {
                  accmType: blk.accmType,
                  blk: blk.blk,
                  blkGrp: blk.blkGrp,
                  blksGrp1: blk.blksGrp1,
                  blksGrp2: blk.blksGrp2,
                  blkDesc: blk.blkDesc,
                  inclNorm: blk.inclNorm,
                  ownLim: blk.ownLim,
                  ownRtn: blk.ownRtn
                }
                this.blkItems.push(convertBlk)
              })
            } else {
              this.blkItems = []
            }
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
        }
      }
    },
    async getAccumTypeLabel() {
      const apiUrl = this.riskAccumulationList.getAccumType
      const requestParams = {
        accmType: this.riskAccumForm.accumType
      }
      if (apiUrl) {
        try {
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          const { data } = result.data
          if (data) {
            if (this.riskAccumForm.accumType === 'X') {
              this.labels.blksLblS = 'Vessel No.'
            }
            if (data.accumType.blkGrpLblS !== undefined) {
              this.labels.blkGrpLblS = data.accumType.blkGrpLblS
              this.accumBlkItem.push({ label: data.accumType.blkGrpLblS, value: 'blkGrp' })
            } else {
              this.labels.blkGrpLblS = '-'
              this.blkGrpDisable = true
            }
            if (data.accumType.blkSgrp1LblS !== undefined && data.accumType.blkSgrp1LblS !== '') {
              this.labels.blksGrp1LblS = data.accumType.blkSgrp1LblS
              this.accumBlkItem.push({ label: data.accumType.blkSgrp1LblS, value: 'blksGrp1' })
            } else {
              this.labels.blksGrp1LblS = '-'
              this.blksGrp1Disable = true
            }
            if (data.accumType.blkSgrp2LblS !== undefined && data.accumType.blkSgrp2LblS !== '') {
              this.labels.blksGrp2LblS = data.accumType.blkSgrp2LblS
              this.accumBlkItem.push({ label: data.accumType.blkSgrp2LblS, value: 'blksGrp2' })
            } else {
              this.labels.blksGrp2LblS = '-'
              this.blksGrp2Disable = true
            }
            if (this.riskAccumForm.accumType !== undefined && this.riskAccumForm.accumType === 'X') {
              this.labels.blksLblS = 'Vessel No.'
              this.accumBlkItem.push({ label: 'Vessel No.', value: 'blk' })
            } else if (data.accumType.blkLblS !== undefined) {
              this.labels.blksLblS = data.accumType.blkLblS
              this.accumBlkItem.push({ label: data.accumType.blkLblS, value: 'blk' })
            } else {
              this.labels.blksLblS = '-'
              this.blkDisable = true
            }
          } else {
            this.labels.blksLblS = 'Block Label'
            this.labels.blkGrpLblS = 'Block Group Label'
            this.labels.blksGrp1LblS = 'Block Sub Group 1 Label'
            this.labels.blksGrp2LblS = 'Block Sub Group 2 Label'
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
        }
      }
    },
    async getAccumTypeTransferLabel() {
      const apiUrl = this.riskAccumulationList.getAccumType
      const requestParams = {
        accmType: this.transferForm.accumType
      }
      if (apiUrl) {
        try {
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          const { data } = result.data
          if (data) {
            if (this.transferForm.accumType === 'X') {
              this.transferLabels.blksLblS = 'Vessel No.'
            }
            if (data.accumType.blkGrpLblS !== undefined) {
              this.transferLabels.blkGrpLblS = data.accumType.blkGrpLblS
              this.accumBlkItem.push({ label: data.accumType.blkGrpLblS, value: 'blkGrp' })
            } else {
              this.transferLabels.blkGrpLblS = '-'
              this.blkGrpDisable = true
            }
            if (data.accumType.blkSgrp1LblS !== undefined && data.accumType.blkSgrp1LblS !== '') {
              this.transferLabels.blksGrp1LblS = data.accumType.blkSgrp1LblS
              this.accumBlkItem.push({ label: data.accumType.blkSgrp1LblS, value: 'blksGrp1' })
            } else {
              this.transferLabels.blksGrp1LblS = '-'
              this.blksGrp1Disable = true
            }
            if (data.accumType.blkSgrp2LblS !== undefined && data.accumType.blkSgrp2LblS !== '') {
              this.transferLabels.blksGrp2LblS = data.accumType.blkSgrp2LblS
              this.accumBlkItem.push({ label: data.accumType.blkSgrp2LblS, value: 'blksGrp2' })
            } else {
              this.transferLabels.blksGrp2LblS = '-'
              this.blksGrp2Disable = true
            }
            if (this.transferForm.accumType !== undefined && this.transferForm.accumType === 'X') {
              this.transferLabels.blksLblS = 'Vessel No.'
              this.accumBlkItem.push({ label: 'Vessel No.', value: 'blk' })
            } else if (data.accumType.blkLblS !== undefined) {
              this.transferLabels.blksLblS = data.accumType.blkLblS
              this.accumBlkItem.push({ label: data.accumType.blkLblS, value: 'blk' })
            } else {
              this.transferLabels.blksLblS = '-'
              this.blkDisable = true
            }
          } else {
            this.transferLabels.blksLblS = 'Block Label'
            this.transferLabels.blkGrpLblS = 'Block Group Label'
            this.transferLabels.blksGrp1LblS = 'Block Sub Group 1 Label'
            this.transferLabels.blksGrp2LblS = 'Block Sub Group 2 Label'
          }
          return true
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
          return false
        }
      }
    },
    async getAccumTypeExtraBlkLabel() {
      const apiUrl = this.riskAccumulationList.getAccumType
      const requestParams = {
        accmType: this.extraBlkForm.accumType
      }
      if (apiUrl) {
        try {
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          const { data } = result.data
          if (data) {
            if (this.extraBlkForm.accumType === 'X') {
              this.extraBlkLabels.blksLblS = 'Vessel No.'
            }
            if (data.accumType.blkGrpLblS !== undefined) {
              this.extraBlkLabels.blkGrpLblS = data.accumType.blkGrpLblS
              this.accumBlkItem.push({ label: data.accumType.blkGrpLblS, value: 'blkGrp' })
            } else {
              this.extraBlkLabels.blkGrpLblS = '-'
              this.blkGrpDisable = true
            }
            if (data.accumType.blkSgrp1LblS !== undefined && data.accumType.blkSgrp1LblS !== '') {
              this.extraBlkLabels.blksGrp1LblS = data.accumType.blkSgrp1LblS
              this.accumBlkItem.push({ label: data.accumType.blkSgrp1LblS, value: 'blksGrp1' })
            } else {
              this.extraBlkLabels.blksGrp1LblS = '-'
              this.blksGrp1Disable = true
            }
            if (data.accumType.blkSgrp2LblS !== undefined && data.accumType.blkSgrp2LblS !== '') {
              this.extraBlkLabels.blksGrp2LblS = data.accumType.blkSgrp2LblS
              this.accumBlkItem.push({ label: data.accumType.blkSgrp2LblS, value: 'blksGrp2' })
            } else {
              this.extraBlkLabels.blksGrp2LblS = '-'
              this.blksGrp2Disable = true
            }
            if (this.extraBlkForm.accumType !== undefined && this.extraBlkForm.accumType === 'X') {
              this.extraBlkLabels.blksLblS = 'Vessel No.'
              this.accumBlkItem.push({ label: 'Vessel No.', value: 'blk' })
            } else if (data.accumType.blkLblS !== undefined) {
              this.extraBlkLabels.blksLblS = data.accumType.blkLblS
              this.accumBlkItem.push({ label: data.accumType.blkLblS, value: 'blk' })
            } else {
              this.extraBlkLabels.blksLblS = '-'
              this.blkDisable = true
            }
          } else {
            this.extraBlkLabels.blksLblS = 'Block Label'
            this.extraBlkLabels.blkGrpLblS = 'Block Group Label'
            this.extraBlkLabels.blksGrp1LblS = 'Block Sub Group 1 Label'
            this.extraBlkLabels.blksGrp2LblS = 'Block Sub Group 2 Label'
          }
          return true
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
          return false
        }
      }
    },
    async getAccumTypeConfirmBlkLabel() {
      const apiUrl = this.riskAccumulationList.getAccumType
      const requestParams = {
        accmType: this.confirmBlkForm.accumType
      }
      if (apiUrl) {
        try {
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          const { data } = result.data
          if (data) {
            if (this.confirmBlkForm.accumType === 'X') {
              this.confirmBlkLabels.blksLblS = 'Vessel No.'
            }
            if (data.accumType.blkGrpLblS !== undefined) {
              this.confirmBlkLabels.blkGrpLblS = data.accumType.blkGrpLblS
              this.accumBlkItem.push({ label: data.accumType.blkGrpLblS, value: 'blkGrp' })
            } else {
              this.confirmBlkLabels.blkGrpLblS = '-'
              this.blkGrpDisable = true
            }
            if (data.accumType.blkSgrp1LblS !== undefined && data.accumType.blkSgrp1LblS !== '') {
              this.confirmBlkLabels.blksGrp1LblS = data.accumType.blkSgrp1LblS
              this.accumBlkItem.push({ label: data.accumType.blkSgrp1LblS, value: 'blksGrp1' })
            } else {
              this.confirmBlkLabels.blksGrp1LblS = '-'
              this.blksGrp1Disable = true
            }
            if (data.accumType.blkSgrp2LblS !== undefined && data.accumType.blkSgrp2LblS !== '') {
              this.confirmBlkLabels.blksGrp2LblS = data.accumType.blkSgrp2LblS
              this.accumBlkItem.push({ label: data.accumType.blkSgrp2LblS, value: 'blksGrp2' })
            } else {
              this.confirmBlkLabels.blksGrp2LblS = '-'
              this.blksGrp2Disable = true
            }
            if (this.confirmBlkForm.accumType !== undefined && this.confirmBlkForm.accumType === 'X') {
              this.confirmBlkLabels.blksLblS = 'Vessel No.'
              this.accumBlkItem.push({ label: 'Vessel No.', value: 'blk' })
            } else if (data.accumType.blkLblS !== undefined) {
              this.confirmBlkLabels.blksLblS = data.accumType.blkLblS
              this.accumBlkItem.push({ label: data.accumType.blkLblS, value: 'blk' })
            } else {
              this.confirmBlkLabels.blksLblS = '-'
              this.blkDisable = true
            }
          } else {
            this.confirmBlkLabels.blksLblS = 'Block Label'
            this.confirmBlkLabels.blkGrpLblS = 'Block Group Label'
            this.confirmBlkLabels.blksGrp1LblS = 'Block Sub Group 1 Label'
            this.confirmBlkLabels.blksGrp2LblS = 'Block Sub Group 2 Label'
          }
          return true
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
          return false
        }
      }
    },
    async getAccumTypeLoadingPctLabel() {
      const apiUrl = this.riskAccumulationList.getAccumType
      const requestParams = {
        accmType: this.loadingPctForm.accumType
      }
      if (apiUrl) {
        try {
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          const { data } = result.data
          if (data) {
            if (this.loadingPctForm.accumType === 'X') {
              this.loadingPctLabels.blksLblS = 'Vessel No.'
            }
            if (data.accumType.blkGrpLblS !== undefined) {
              this.loadingPctLabels.blkGrpLblS = data.accumType.blkGrpLblS
              this.accumBlkItem.push({ label: data.accumType.blkGrpLblS, value: 'blkGrp' })
            } else {
              this.loadingPctLabels.blkGrpLblS = '-'
              this.blkGrpDisable = true
            }
            if (data.accumType.blkSgrp1LblS !== undefined && data.accumType.blkSgrp1LblS !== '') {
              this.loadingPctLabels.blksGrp1LblS = data.accumType.blkSgrp1LblS
              this.accumBlkItem.push({ label: data.accumType.blkSgrp1LblS, value: 'blksGrp1' })
            } else {
              this.loadingPctLabels.blksGrp1LblS = '-'
              this.blksGrp1Disable = true
            }
            if (data.accumType.blkSgrp2LblS !== undefined && data.accumType.blkSgrp2LblS !== '') {
              this.loadingPctLabels.blksGrp2LblS = data.accumType.blkSgrp2LblS
              this.accumBlkItem.push({ label: data.accumType.blkSgrp2LblS, value: 'blksGrp2' })
            } else {
              this.loadingPctLabels.blksGrp2LblS = '-'
              this.blksGrp2Disable = true
            }
            if (this.loadingPctForm.accumType !== undefined && this.loadingPctForm.accumType === 'X') {
              this.loadingPctLabels.blksLblS = 'Vessel No.'
              this.accumBlkItem.push({ label: 'Vessel No.', value: 'blk' })
            } else if (data.accumType.blkLblS !== undefined) {
              this.loadingPctLabels.blksLblS = data.accumType.blkLblS
              this.accumBlkItem.push({ label: data.accumType.blkLblS, value: 'blk' })
            } else {
              this.loadingPctLabels.blksLblS = '-'
              this.blkDisable = true
            }
          } else {
            this.loadingPctLabels.blksLblS = 'Block Label'
            this.loadingPctLabels.blkGrpLblS = 'Block Group Label'
            this.loadingPctLabels.blksGrp1LblS = 'Block Sub Group 1 Label'
            this.loadingPctLabels.blksGrp2LblS = 'Block Sub Group 2 Label'
          }
          return true
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
          return false
        }
      }
    },
    async checkBlkGrp(blk) {
      const apiUrl = this.riskAccumulationList.getBlkGrpByBlk
      const requestParams = {
        accmType: this.riskAccumForm.accumType,
        blkGrp: blk.blkGrp
      }
      if (apiUrl) {
        try {
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          const { data } = result.data
          if (data) {
            this.riskAccumForm.blkGrpLblS = data.blkGrp.blkGrp
            this.riskAccumForm.blkGrpLblL = data.blkGrp.blkGrpDescS
            return true
          } else {
            return false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          return false
        }
      }
    },
    async checkBlkGrpTransfTo(blk) {
      const apiUrl = this.riskAccumulationList.getBlkGrpByBlk
      const requestParams = {
        accmType: this.transferForm.accumType,
        blkGrp: blk.blkGrp
      }
      if (apiUrl) {
        try {
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          const { data } = result.data
          if (data) {
            this.transferForm.blkGrpLblSTo = data.blkGrp.blkGrp
            this.transferForm.blkGrpLblLTo = data.blkGrp.blkGrpDescS
            return true
          } else {
            return false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          return false
        }
      }
    },
    async checkBlkGrpExtraBlk(blk) {
      const apiUrl = this.riskAccumulationList.getBlkGrpByBlk
      const requestParams = {
        accmType: this.extraBlkForm.accumType,
        blkGrp: blk.blkGrp
      }
      if (apiUrl) {
        try {
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          const { data } = result.data
          if (data) {
            this.extraBlkForm.blkGrpLblS = data.blkGrp.blkGrp
            this.extraBlkForm.blkGrpLblL = data.blkGrp.blkGrpDescS
            return true
          } else {
            return false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          return false
        }
      }
    },
    async checkBlkSubGrp1(blk) {
      const apiUrl = this.riskAccumulationList.getBlkSubGrp1ByBlk
      const requestParams = {
        accmType: this.riskAccumForm.accumType,
        blkGrp: blk.blkGrp,
        blksGrp1: blk.blksGrp1
      }
      if (apiUrl) {
        try {
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          const { data } = result.data
          if (data) {
            this.riskAccumForm.blksGrp1LblS = data.blkSubGrp1.blksGrp1
            this.riskAccumForm.blksGrp1LblL = data.blkSubGrp1.blksGrp1DescS
            return true
          } else {
            return false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          return false
        }
      }
    },
    async checkBlkSubGrp2(blk) {
      const apiUrl = this.riskAccumulationList.getBlkSubGrp2ByBlk
      const requestParams = {
        accmType: this.riskAccumForm.accumType,
        blkGrp: blk.blkGrp,
        blksGrp1: blk.blksGrp1,
        blksGrp2: blk.blksGrp2
      }
      if (apiUrl) {
        try {
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          const { data } = result.data
          if (data) {
            this.riskAccumForm.blksGrp2LblS = data.blkSubGrp2.blksGrp2
            this.riskAccumForm.blksGrp2LblL = data.blkSubGrp2.blksGrp2DescS
            return true
          } else {
            return false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          return false
        }
      }
    },
    async doSelectBlk(blk) {
      if (this.transferAll) {
        if (this.transferForm.transferType === 'transferFrom') {
          if (this.transferForm.accumType !== undefined) {
            this.checkBlkGrp(blk)
            // if (blk.blksGrp1 !== undefined) {
            //   this.checkBlkSubGrp1(blk)
            // }
            // if (blk.blksGrp2 !== undefined) {
            //   this.checkBlkSubGrp2(blk)
            // }
            this.transferForm.blksLblSFrom = blk.blk
            this.transferForm.blksLblLFrom = blk.blkDesc
            // this.transferForm.inclNorm = blk.inclNorm
            this.riskAccumBlkDialog = false
          }
        } else if (this.transferForm.transferType === 'transferTo') {
          if (this.transferForm.accumType !== undefined) {
            this.checkBlkGrpTransfTo(blk)
            // if (blk.blksGrp1 !== undefined) {
            //   this.checkBlkSubGrp1(blk)
            // }
            // if (blk.blksGrp2 !== undefined) {
            //   this.checkBlkSubGrp2(blk)
            // }
            this.transferForm.blksLblSTo = blk.blk
            this.transferForm.blksLblLTo = blk.blkDesc
            // this.transferForm.inclNorm = blk.inclNorm
            this.riskAccumBlkDialog = false
          }
        }
      } else if (this.showExtraBlk) {
        if (this.extraBlkForm.accumType !== undefined) {
          this.checkBlkGrpExtraBlk(blk)
          // if (blk.blksGrp1 !== undefined) {
          //   this.checkBlkSubGrp1ExtraBlk(blk)
          // }
          // if (blk.blksGrp2 !== undefined) {
          //   this.checkBlkSubGrp2ExtraBlk(blk)
          // }
          this.extraBlkForm.blksLblS = blk.blk
          this.extraBlkForm.blksLblL = blk.blkDesc
          this.extraBlkForm.inclNorm = blk.inclNorm
          this.riskAccumBlkDialog = false
        }
      } else {
        if (this.riskAccumForm.accumType !== undefined) {
          this.checkBlkGrp(blk)
          if (blk.blksGrp1 !== undefined) {
            this.checkBlkSubGrp1(blk)
          }
          if (blk.blksGrp2 !== undefined) {
            this.checkBlkSubGrp2(blk)
          }
          this.riskAccumForm.blksLblS = blk.blk
          this.riskAccumForm.blksLblL = blk.blkDesc
          this.riskAccumForm.inclNorm = blk.inclNorm
          this.riskAccumForm.rtnLimKey = formatPrice(blk.ownRtn)
          this.riskAccumBlkDialog = false
        }
      }
    },
    async riskAccumVslDetInit() {
      const apiUrl = this.riskAccumulationList.getVslDetLists
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationVslDet
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          const params = {
            accmType: this.riskAccumForm.accumType,
            vesNo: this.filters.blk
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), params, this.paginationVslDet.sortBy, this.paginationVslDet.descending))
          if (result.data) {
            this.totalItemsVslDet = result.data.totalElements
            const { data } = result.data
            this.vslDetItems = []
            if (data) {
              data.map(vslDet => {
                const convertBlkGrp = {
                  accmType: vslDet.accmType,
                  vesNo: vslDet.vesNo,
                  vesName: vslDet.vesName
                }
                this.vslDetItems.push(convertBlkGrp)
              })
            } else {
              this.vslDetItems = []
            }
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
        }
      }
    },
    async doSelectVslDet(vslDet) {
      if (this.transferAll) {
        if (this.transferForm.transferType === 'transferFrom') {
          if (this.transferForm.accumType !== undefined) {
            this.transferForm.blksLblSFrom = vslDet.vesNo
            this.transferForm.blksLblLFrom = vslDet.vesName
            this.riskAccumVslDetDialog = false
          }
        } else if (this.transferForm.transferType === 'transferTo') {
          if (this.transferForm.accumType !== undefined) {
            this.transferForm.blksLblSTo = vslDet.vesNo
            this.transferForm.blksLblLTo = vslDet.vesName
            this.riskAccumVslDetDialog = false
          }
        }
      } else {
        if (this.riskAccumForm.accumType !== undefined) {
          this.riskAccumForm.blksLblS = vslDet.vesNo
          this.riskAccumForm.blksLblL = vslDet.vesName
          this.riskAccumVslDetDialog = false
        }
      }
    },
    async checkAccumulation() {
      const apiUrl = this.riskAccumulationList.getAccumLists
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationRiskAccumDetail
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          const params = {
            accmType: this.riskAccumForm.accumType,
            blkGrpLblS: this.riskAccumForm.blkGrpLblS,
            blksGrp1LblS: this.riskAccumForm.blksGrp1LblS,
            blksGrp2LblS: this.riskAccumForm.blksGrp2LblS,
            blksLblS: this.riskAccumForm.blksLblS,
            currency: this.riskAccumForm.currency,
            accumBlkLbl: this.riskAccumForm.accumBlkLbl,
            filterBy: this.riskAccumForm.filterBy,
            asAtDate: formatDisplayDate(this.riskAccumForm.asAtDate),
            accumBase: this.riskAccumForm.accumBase
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), params, this.paginationRiskAccumDetail.sortBy, this.paginationRiskAccumDetail.descending))
          if (result.data) {
            this.totalItemsRiskAccumDetail = result.data.totalElements
            this.riskAccumDetailItems = []
            const { data } = result.data
            if (data) {
              data.map(polRiskBlk => {
                const convertBlkGrp = {
                  polNo: polRiskBlk.polNo,
                  renCnt: polRiskBlk.renCnt,
                  endtCnt: polRiskBlk.endtCnt,
                  riskGrp: polRiskBlk.riskGrpNo,
                  riskNo: polRiskBlk.riskNo,
                  seqNo: polRiskBlk.seqNo,
                  accumType: polRiskBlk.accmType,
                  blkGrp: polRiskBlk.blkGrp,
                  blksGrp1: polRiskBlk.blksGrp1,
                  blksGrp2: polRiskBlk.blksGrp2,
                  blk: polRiskBlk.blk,
                  insdName1: polRiskBlk.insdName1,
                  busClsAppId: polRiskBlk.busClsAppId,
                  busCls: polRiskBlk.busCls,
                  busClsDesc: polRiskBlk.busClsDesc,
                  comDate: formatDisplayDate(polRiskBlk.comDate),
                  expDate: formatDisplayDate(polRiskBlk.expDate),
                  currency: polRiskBlk.siCurr,
                  currDesc: polRiskBlk.currDesc,
                  siExRate: polRiskBlk.siExRate,
                  billCurr: polRiskBlk.billCurr,
                  billCurrDesc: polRiskBlk.billCurrDesc,
                  billCurrRate: polRiskBlk.billCurrRate,
                  sumInsd: polRiskBlk.riSi,
                  sumInsdDisp: formatPrice(polRiskBlk.riSi),
                  premDue: polRiskBlk.premDue,
                  premDueDisp: formatPrice(polRiskBlk.premDue),
                  iCount: polRiskBlk.iCount,
                  ttyNo1: polRiskBlk.ttySI1,
                  ttyNo1Disp: formatPrice(polRiskBlk.ttySI1),
                  ttyNo2: polRiskBlk.ttySI2,
                  ttyNo2Disp: formatPrice(polRiskBlk.ttySI2),
                  ttyNo3: polRiskBlk.ttySI3,
                  ttyNo3Disp: formatPrice(polRiskBlk.ttySI3),
                  ttyNo4: polRiskBlk.ttySI4,
                  ttyNo4Disp: formatPrice(polRiskBlk.ttySI4),
                  ttyNo5: polRiskBlk.ttySI5,
                  ttyNo5Disp: formatPrice(polRiskBlk.ttySI5),
                  ttyNo6: polRiskBlk.ttySI6,
                  ttyNo6Disp: formatPrice(polRiskBlk.ttySI6),
                  ttyNo7: polRiskBlk.ttySI7,
                  ttyNo7Disp: formatPrice(polRiskBlk.ttySI7),
                  ttyNo8: polRiskBlk.ttySI8,
                  ttyNo8Disp: formatPrice(polRiskBlk.ttySI8),
                  ttyNo9: polRiskBlk.ttySI9,
                  ttyNo9Disp: formatPrice(polRiskBlk.ttySI9),
                  ttyNo10: polRiskBlk.ttySI10,
                  ttyNo10Disp: formatPrice(polRiskBlk.ttySI10),
                  coinSumInsd: polRiskBlk.coInsSi,
                  coinSumInsdDisp: formatPrice(polRiskBlk.coInsSi),
                  coinPct: polRiskBlk.coInsPct,
                  statSumInsd: polRiskBlk.statSi,
                  statSumInsdDisp: formatPrice(polRiskBlk.statSi),
                  statPct: polRiskBlk.statPct,
                  facSumInsd: polRiskBlk.facSi,
                  facSumInsdDisp: formatPrice(polRiskBlk.facSi),
                  facPct: polRiskBlk.facPct,
                  treatySumInsd: polRiskBlk.treatySi,
                  treatySumInsdDisp: formatPrice(polRiskBlk.treatySi),
                  treatyPct: polRiskBlk.treatyPct,
                  grossRet: polRiskBlk.grossRet,
                  grossRetDisp: formatPrice(polRiskBlk.grossRet),
                  grossPct: polRiskBlk.grossRetPct,
                  qShareSumInsd: polRiskBlk.qShareSi,
                  qShareSumInsdDisp: formatPrice(polRiskBlk.qShareSi),
                  qSharePct: polRiskBlk.qSharePct,
                  netRet: polRiskBlk.netRet,
                  netRetDisp: formatPrice(polRiskBlk.netRet),
                  netPct: polRiskBlk.netRetPct,
                  delRisk: polRiskBlk.delRisk,
                  cfmRisk: polRiskBlk.cfmRisk,
                  cfmRiskDisp: formatYesNo(polRiskBlk.cfmRisk),
                  bldgNo: polRiskBlk.bldgNo,
                  unitNo: polRiskBlk.unitNo
                }
                this.riskAccumDetailItems.push(convertBlkGrp)
                // this.riskAccumForm.rtnLimKey = polRiskBlk.rtnLim
              })
              this.loading = false
            } else {
              this.riskAccumDetailItems = []
              this.processLoading = false
              this.loading = false
            }
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
          this.processLoading = false
          this.loading = false
        }
      }
    },
    // print block register
    async doPrint() {
      if (this.riskAccumForm.accumType === 'F' && this.riskAccumForm.blkGrpLblS === 'A082' && this.riskAccumForm.blksLblS === 'UPP001') {
        const apiUrl = this.menu.exportBlkRegisterOptimization
        if (apiUrl) {
          try {
            this.processing = true
            const params = {
              accumType: this.riskAccumForm.accumType,
              blkGrpLblS: this.riskAccumForm.blkGrpLblS,
              blksGrp1LblS: this.riskAccumForm.blksGrp1LblS,
              blksGrp2LblS: this.riskAccumForm.blksGrp2LblS,
              blksLblS: this.riskAccumForm.blksLblS,
              currency: this.riskAccumForm.currency,
              accumBlkLbl: this.riskAccumForm.accumBlkLbl,
              filterBy: this.riskAccumForm.filterBy,
              asAtDate: this.riskAccumForm.asAtDate,
              accumBase: this.riskAccumForm.accumBase,
              ttTreatyTotals: this.riskAccumulationDto.ttTreatyTotals,
              cTtyRet: this.riskAccumulationDto.cTtyRet,
              rtnLimKey: this.riskAccumForm.rtnLimKey,
              format: this.riskAccumForm.format
            }
            await this.$http.post(apiUrl, params)
            this.$toast.success('Submitted Successfully.')
            this.processing = false
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
            this.processing = false
          }
        } else {
          this.$toast.error('The request failed because it is trying to execute an invalid API url. [exportBlkRegister]')
        }
      } else {
        const apiUrl = this.menu.exportBlkRegister
        if (apiUrl) {
          try {
            this.processing = true
            const params = {
              accumType: this.riskAccumForm.accumType,
              blkGrpLblS: this.riskAccumForm.blkGrpLblS,
              blksGrp1LblS: this.riskAccumForm.blksGrp1LblS,
              blksGrp2LblS: this.riskAccumForm.blksGrp2LblS,
              blksLblS: this.riskAccumForm.blksLblS,
              currency: this.riskAccumForm.currency,
              accumBlkLbl: this.riskAccumForm.accumBlkLbl,
              filterBy: this.riskAccumForm.filterBy,
              asAtDate: this.riskAccumForm.asAtDate,
              accumBase: this.riskAccumForm.accumBase,
              ttPolBlocks: this.riskAccumulationDto.ttPolBlocks,
              ttTreatyTotals: this.riskAccumulationDto.ttTreatyTotals,
              cTtyRet: this.riskAccumulationDto.cTtyRet,
              rtnLimKey: this.riskAccumForm.rtnLimKey,
              format: this.riskAccumForm.format
            }
            await this.$http.post(apiUrl, params)
            this.$toast.success('Submitted Successfully.')
            this.processing = false
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
            this.processing = false
          }
        } else {
          this.$toast.error('The request failed because it is trying to execute an invalid API url. [exportBlkRegister]')
        }
      }
    },
    // print Custom block register without risk Accumulation
    async doCustomPrint() {
      const apiUrl = this.menu.exportCustomBlkRegister
      if (apiUrl) {
        try {
          this.processing = true
          const params = {
            accumType: this.riskAccumForm.accumType,
            blkGrpLblS: this.riskAccumForm.blkGrpLblS,
            blksGrp1LblS: this.riskAccumForm.blksGrp1LblS,
            blksGrp2LblS: this.riskAccumForm.blksGrp2LblS,
            blksLblS: this.riskAccumForm.blksLblS,
            currency: this.riskAccumForm.currency,
            accumBlkLbl: this.riskAccumForm.accumBlkLbl,
            filterBy: this.riskAccumForm.filterBy,
            asAtDate: this.riskAccumForm.asAtDate,
            accumBase: this.riskAccumForm.accumBase,
            cTtyRet: this.riskAccumulationDto.cTtyRet,
            rtnLimKey: this.riskAccumForm.rtnLimKey,
            format: this.riskAccumForm.format
          }
          await this.$http.post(apiUrl, params)
          this.$toast.success('Submitted Successfully.')
          this.processing = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.processing = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url. [exportBlkRegister]')
      }
    },
    async getAccumListTotal() {
      const apiUrl = this.riskAccumulationList.getAccumListTotal
      const params = {
        accmType: this.riskAccumForm.accumType,
        blkGrpLblS: this.riskAccumForm.blkGrpLblS,
        blksGrp1LblS: this.riskAccumForm.blksGrp1LblS,
        blksGrp2LblS: this.riskAccumForm.blksGrp2LblS,
        blksLblS: this.riskAccumForm.blksLblS,
        currency: this.riskAccumForm.currency,
        accumBlkLbl: this.riskAccumForm.accumBlkLbl,
        filterBy: this.riskAccumForm.filterBy,
        asAtDate: formatDisplayDate(this.riskAccumForm.asAtDate)
      }
      if (apiUrl) {
        try {
          this.loading = true
          const result = await this.$http.get(expandURI(apiUrl, params))
          const { data } = result.data
          this.riskAccumDetailItemsTotal = []
          if (data) {
            data.map(accumListTotal => {
              const convertAccumListTotal = {
                sumInsd: accumListTotal.riSi,
                sumInsdLoc: accumListTotal.riSiLoc,
                sumInsdDisp: formatPrice(accumListTotal.riSi),
                coinSumInsd: accumListTotal.coInsSi,
                coinSumInsdLoc: accumListTotal.coInsLoc,
                coinSumInsdDisp: formatPrice(accumListTotal.coInsSi),
                coinPct: accumListTotal.coInsPct,
                statSumInsd: accumListTotal.statSi,
                statSumInsdLoc: accumListTotal.statLoc,
                statSumInsdDisp: formatPrice(accumListTotal.statSi),
                statPct: accumListTotal.statPct,
                facSumInsd: accumListTotal.facSi,
                facSumInsdLoc: accumListTotal.facLoc,
                facSumInsdDisp: formatPrice(accumListTotal.facSi),
                facPct: accumListTotal.facPct,
                treatySumInsd: accumListTotal.treatySi,
                treatySumInsdLoc: accumListTotal.treatyLoc,
                treatySumInsdDisp: formatPrice(accumListTotal.treatySi),
                treatyPct: accumListTotal.treatyPct,
                grossRet: accumListTotal.grossRet,
                grossRetLoc: accumListTotal.grossRetLoc,
                grossRetDisp: formatPrice(accumListTotal.grossRet),
                grossPct: accumListTotal.grossRetPct,
                qShareSumInsd: accumListTotal.qShareSi,
                qShareSumInsdLoc: accumListTotal.qShareLoc,
                qShareSumInsdDisp: formatPrice(accumListTotal.qShareSi),
                qSharePct: accumListTotal.qSharePct,
                netRet: accumListTotal.netRet,
                netRetLoc: accumListTotal.netRetLoc,
                netRetDisp: formatPrice(accumListTotal.netRet),
                netPct: accumListTotal.netRetPct
              }
              this.loading = false
              this.riskAccumDetailItemsTotal.push(convertAccumListTotal)
            })
            // this.processLoading = false
          } else {
            this.processLoading = false
            this.riskAccumDetailItemsTotal = []
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
          this.processLoading = false
          this.loading = false
        }
      }
    },
    async getTreatyTotal() {
      const apiUrl = this.riskAccumulationList.getTreatyTotal
      const params = {
        accmType: this.riskAccumForm.accumType,
        blkGrpLblS: this.riskAccumForm.blkGrpLblS,
        blksGrp1LblS: this.riskAccumForm.blksGrp1LblS,
        blksGrp2LblS: this.riskAccumForm.blksGrp2LblS,
        blksLblS: this.riskAccumForm.blksLblS,
        currency: this.riskAccumForm.currency,
        accumBlkLbl: this.riskAccumForm.accumBlkLbl,
        filterBy: this.riskAccumForm.filterBy,
        asAtDate: formatDisplayDate(this.riskAccumForm.asAtDate)
      }
      if (apiUrl) {
        try {
          this.loading = true
          const result = await this.$http.get(expandURI(apiUrl, params))
          const { data } = result.data
          this.totalTreatyTotal = result.data.totalElements
          this.treatyTotalItems = []
          if (data) {
            if (data.length > 0) {
              this.treatyItemList = true
            }
            data.map(treatyTotalList => {
              const convertTreatyTotalList = {
                ttyNo: treatyTotalList.ttyNo,
                ttyLim: treatyTotalList.ttyLim,
                ttyLimDisp: formatPrice(treatyTotalList.ttyLim),
                treatyTotal: treatyTotalList.ttyTotal,
                treatyTotalDisp: formatPrice(treatyTotalList.ttyTotal),
                bal: treatyTotalList.bal,
                balDisp: formatPrice(treatyTotalList.bal)
              }
              this.treatyTotalItems.push(convertTreatyTotalList)
            })
            this.addHeader(this.treatyTotalItems)
            this.loading = false
            this.processLoading = false
          } else {
            this.treatyTotalItems = []
            this.loading = false
            this.treatyItemList = false
            this.processLoading = false
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
          this.treatyTotalItems = []
          this.loading = false
          this.treatyItemList = false
          this.processLoading = false
        }
      }
    },
    // SSY - To Check if required to add new column & push new column with text and value
    addHeader(treatyTotal) {
      for (const updateHeader of treatyTotal) {
        let findCol = this.riskAccumDetailColumns.find(a => updateHeader === a.value)
        let findCol2 = this.riskAccumDetailColumns.find(a => 'ttyNo' + this.count + 'Disp' === a.value)
        if (!findCol && updateHeader.ttyNo !== '') {
          const ttTreaty = {
            text: updateHeader.ttyNo,
            value: 'ttyNo' + this.count + 'Disp'
          }
          this.riskAccumDetailColumns.push(ttTreaty)
        } else if (!findCol && updateHeader.ttyNo !== findCol.text && findCol2) {
          findCol.text = updateHeader.ttyNo
        }
        this.count = this.count + 1
      }
      // SSY - To check if new pushed column is created & remove columns not required
      var icount = 0
      if (this.riskAccumForm.accumType === 'F') {
        for (const removeTtyNo of this.selectedRiskAccumDetailFireColumns) {
          // for (var i = 0; i < this.selectedRiskAccumDetailColumns.length; i++) {
          let removeCol = this.riskAccumDetailColumns.find(a => removeTtyNo === a.value)
          // let removeCol = this.riskAccumDetailColumns.find(a => this.selectedRiskAccumDetailColumns[i] === a.value)
          if (removeCol) {
            // this.removeColumns.push(this.selectedRiskAccumDetailColumns[icount])
            this.newColumns.push(this.selectedRiskAccumDetailFireColumns[icount])
            this.icount = icount++
            // this.selectedRiskAccumDetailColumns.splice(icount, 1)
            // this.selectedRiskAccumDetailColumns.splice(this.selectedRiskAccumDetailColumns.indexOf(this.selectedRiskAccumDetailColumns.find(x => x === this.selectedRiskAccumDetailColumns[icount])), 1)
            // this.icount = icount--
          } else {
            this.icount = icount++
          }
        }
      } else {
        for (const removeTtyNo of this.selectedRiskAccumDetailColumns) {
          // for (var i = 0; i < this.selectedRiskAccumDetailColumns.length; i++) {
          let removeCol = this.riskAccumDetailColumns.find(a => removeTtyNo === a.value)
          // let removeCol = this.riskAccumDetailColumns.find(a => this.selectedRiskAccumDetailColumns[i] === a.value)
          if (removeCol) {
            // this.removeColumns.push(this.selectedRiskAccumDetailColumns[icount])
            this.newColumns.push(this.selectedRiskAccumDetailColumns[icount])
            this.icount = icount++
            // this.selectedRiskAccumDetailColumns.splice(icount, 1)
            // this.selectedRiskAccumDetailColumns.splice(this.selectedRiskAccumDetailColumns.indexOf(this.selectedRiskAccumDetailColumns.find(x => x === this.selectedRiskAccumDetailColumns[icount])), 1)
            // this.icount = icount--
          } else {
            this.icount = icount++
          }
        }
      }
    },
    async getPolFireRiskDet(accumDet) {
      const apiUrl = this.riskAccumulationList.getPolFireRiskDet
      const requestParams = {
        polNo: accumDet.polNo,
        renCnt: accumDet.renCnt,
        endtCnt: accumDet.endtCnt,
        riskGrpNo: accumDet.riskGrp,
        riskNo: accumDet.riskNo
      }
      if (apiUrl) {
        try {
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          const { data } = result.data
          if (data) {
            this.riskAccumDetailForm.bldgNo = data.polFireRisk.bldgNo
            this.riskAccumDetailForm.unitNo = data.polFireRisk.unitNo
            this.riskAccumDetailForm.interest = data.polFireRisk.interest
            this.riskAccumDetailForm.riskLoc = data.polFireRisk.riskLoc
            this.riskAccumDetailForm.riskPostCode = data.polFireRisk.riskPostCode
            this.riskAccumDetailForm.occpy = data.polFireRisk.occpy
            this.riskAccumDetailForm.occpCls = data.polFireRisk.occpCls
            this.riskAccumDetailForm.occpClsDesc = data.polFireRisk.occpClsDesc
            this.riskAccumDetailForm.distCls = data.polFireRisk.distCls
            this.riskAccumDetailForm.distClsDesc = data.polFireRisk.distClsDesc
            this.riskAccumDetailForm.constnCls = data.polFireRisk.constnCls
            this.riskAccumDetailForm.constnClsDesc = data.polFireRisk.constnClsDesc
            this.riskAccumDetailForm.occpClsLim = data.polFireRisk.occpClsLim
            this.riskAccumDetailForm.occpClsLimDesc = data.polFireRisk.occpClsLimDesc
            if (data.polFireRisk.ownTent === true) {
              this.riskAccumDetailForm.ownTent = 'Owner'
            } else {
              this.riskAccumDetailForm.ownTent = 'Tenant'
            }
            this.riskAccumDetailForm.accmLdgPct = data.polFireRisk.accmLdgPct
            this.riskAccumDetailForm.roof = data.polFireRisk.roof
            this.riskAccumDetailForm.noStorey = data.polFireRisk.noStorey
            this.riskAccumDetailForm.latitude = data.polFireRisk.latitude
            this.riskAccumDetailForm.longitude = data.polFireRisk.longitude
            this.riskAccumDetailForm.survRpt = data.polFireRisk.survRpt
            this.riskAccumDetailForm.survDate = formatDisplayDate(data.polFireRisk.survDate)
            this.riskAccumDetailForm.comDate = formatDisplayDate(data.polFireRisk.comDate)
            this.riskAccumDetailForm.expDate = formatDisplayDate(data.polFireRisk.expDate)
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      }
    },
    async getFireRiskRI(accumDet) {
      const apiUrl = this.riskAccumulationList.getFireRiskRI
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationFireRiskRI
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          const requestParams = {
            polNo: this.riskAccumDetailForm.polNo,
            renCnt: this.riskAccumDetailForm.renCnt,
            endtCnt: this.riskAccumDetailForm.endtCnt,
            cesEndtCnt: this.riskAccumDetailForm.cesEndtCnt,
            riskGrpNo: this.riskAccumDetailForm.riskGrp,
            riskNo: this.riskAccumDetailForm.riskNo,
            blkGrp: this.riskAccumDetailForm.blkGrpLblS,
            blk: this.riskAccumDetailForm.blksLblS
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), requestParams, this.paginationFireRiskRI.sortBy, this.paginationFireRiskRI.descending))
          const { data } = result.data
          this.totalItemsRiskAccumFireRiskRI = result.data.totalElements
          this.riskAccumFireRiskRIItem = []
          if (data) {
            data.map(fireRiskRI => {
              const convertFireRiskRI = {
                riType: fireRiskRI.riType,
                riCo: fireRiskRI.riCo,
                acctNoSfx: fireRiskRI.acctNoSfx,
                comDate: formatDisplayDate(fireRiskRI.comDate),
                expDate: formatDisplayDate(fireRiskRI.expDate),
                riSI: this.riskAccumForm.currency === 'L' ? fireRiskRI.riSI * this.riskAccumDetailForm.siExRate : fireRiskRI.riSI,
                riSIDisp: formatPrice(this.riskAccumForm.currency === 'L' ? fireRiskRI.riSI * this.riskAccumDetailForm.siExRate : fireRiskRI.riSI),
                riSIPct: fireRiskRI.riSIPct,
                riPrem: fireRiskRI.riPrem,
                riPremDisp: formatPrice(fireRiskRI.riPrem),
                riComm1: fireRiskRI.riComm1,
                riComm1Disp: formatPrice(fireRiskRI.riComm1),
                riComm2: fireRiskRI.riComm2,
                riComm2Disp: formatPrice(fireRiskRI.riComm2),
                riComm3: fireRiskRI.riComm3,
                riComm3Disp: formatPrice(fireRiskRI.riComm3)
              }
              this.riskAccumFireRiskRIItem.push(convertFireRiskRI)
            })
            this.loading = false
          } else {
            this.loading = false
            this.riskAccumFireRiskRIItem = []
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      }
    },
    async getPolCargoRiskDet(accumDet) {
      const apiUrl = this.riskAccumulationList.getPolCargoRiskDet
      const requestParams = {
        polNo: accumDet.polNo,
        renCnt: accumDet.renCnt,
        endtCnt: accumDet.endtCnt,
        riskGrpNo: accumDet.riskGrp,
        riskNo: accumDet.riskNo
      }
      if (apiUrl) {
        try {
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          const { data } = result.data
          if (data) {
            this.riskAccumDetailForm.vesNo = data.polCargoRisk.vesNo
            this.riskAccumDetailForm.vesName = data.polCargoRisk.vesName
            this.riskAccumDetailForm.voyNo = data.polCargoRisk.voyNo
            this.riskAccumDetailForm.voyDet = data.polCargoRisk.voyDet
            this.riskAccumDetailForm.voyDate = formatDisplayDate(data.polCargoRisk.voyDate)
            this.riskAccumDetailForm.voyDateType = data.polCargoRisk.voyDateType
            this.riskAccumDetailForm.voyDateDesc = data.polCargoRisk.voyDateDesc
            this.riskAccumDetailForm.portDep = data.polCargoRisk.portDep
            this.riskAccumDetailForm.portDepDesc = data.polCargoRisk.portDepDesc
            this.riskAccumDetailForm.portArr = data.polCargoRisk.portArr
            this.riskAccumDetailForm.portArrDesc = data.polCargoRisk.portArrDesc
            this.riskAccumDetailForm.voyDesc = data.polCargoRisk.voyDesc
            this.riskAccumDetailForm.voyDesc2 = data.polCargoRisk.voyDesc2
            this.riskAccumDetailForm.voyArea = data.polCargoRisk.voyArea
            this.riskAccumDetailForm.voyAreaDesc = data.polCargoRisk.crgoVoyDesc
            this.riskAccumDetailForm.coverage = data.polCargoRisk.coverage
            this.riskAccumDetailForm.coverageDesc = data.polCargoRisk.coverageDesc
            this.riskAccumDetailForm.comdtyType = data.polCargoRisk.comdtyType
            this.riskAccumDetailForm.comdtyTypeDesc = data.polCargoRisk.comdtyTypeDesc
            this.riskAccumDetailForm.pkgType = data.polCargoRisk.pkgType
            this.riskAccumDetailForm.pkgTypeDesc = data.polCargoRisk.pkgTypeDesc
            this.riskAccumDetailForm.surAgt = data.polCargoRisk.surAgt
            this.riskAccumDetailForm.surAgtName = data.polCargoRisk.surAgtName
            this.riskAccumDetailForm.surAgtAddress1 = data.polCargoRisk.surAgtAddress1
            this.riskAccumDetailForm.surAgtAddress2 = data.polCargoRisk.surAgtAddress2
            this.riskAccumDetailForm.surAgtAddress3 = data.polCargoRisk.surAgtAddress3
            this.riskAccumDetailForm.surAgtAddress4 = data.polCargoRisk.surAgtAddress4
            this.riskAccumDetailForm.surAgtCty = data.polCargoRisk.surAgtCty
            this.riskAccumDetailForm.surAgtPostalCode = data.polCargoRisk.surAgtPostalCode
            this.riskAccumDetailForm.setAgtName = data.polCargoRisk.setAgtName
            this.riskAccumDetailForm.setAgtAddress1 = data.polCargoRisk.setAgtAddress1
            this.riskAccumDetailForm.setAgtAddress2 = data.polCargoRisk.setAgtAddress2
            this.riskAccumDetailForm.setAgtAddress3 = data.polCargoRisk.setAgtAddress3
            this.riskAccumDetailForm.setAgtAddress4 = data.polCargoRisk.setAgtAddress4
            this.riskAccumDetailForm.setAgtCty = data.polCargoRisk.setAgtCty
            this.riskAccumDetailForm.setAgtPostalCode = data.polCargoRisk.setAgtPostalCode
            this.riskAccumDetailForm.certBord = data.polCargoRisk.certBord
            this.riskAccumDetailForm.dclrCertNo = data.polCargoRisk.dclrCertNo
            this.riskAccumDetailForm.comDate = formatDisplayDate(data.polCargoRisk.comDate)
            this.riskAccumDetailForm.expDate = formatDisplayDate(data.polCargoRisk.expDate)
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      }
    },
    async getCargoRiskRI(accumDet) {
      const apiUrl = this.riskAccumulationList.getCargoRiskRI
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationCargoRiskRI
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          const requestParams = {
            polNo: accumDet.polNo,
            renCnt: accumDet.renCnt,
            cesEndtCnt: accumDet.cesEndtCnt,
            riskGrpNo: accumDet.riskGrp,
            riskNo: accumDet.riskNo
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), requestParams, this.paginationCargoRiskRI.sortBy, this.paginationCargoRiskRI.descending))
          const { data } = result.data
          this.totalItemsRiskAccumCargoRiskRI = data.totalElements
          this.riskAccumCargoRiskRIItem = []
          if (data) {
            data.map(CargoRiskRI => {
              const convertCargoRiskRI = {
                riType: CargoRiskRI.riType,
                riCo: CargoRiskRI.riCo,
                acctNoSfx: CargoRiskRI.acctNoSfx,
                comDate: formatDisplayDate(CargoRiskRI.comDate),
                expDate: formatDisplayDate(CargoRiskRI.expDate),
                riSI: this.riskAccumForm.currency === 'L' ? CargoRiskRI.riSI * this.riskAccumDetailForm.siExRate : CargoRiskRI.riSI,
                riSIDisp: formatPrice(this.riskAccumForm.currency === 'L' ? CargoRiskRI.riSI * this.riskAccumDetailForm.siExRate : CargoRiskRI.riSI),
                riSIPct: CargoRiskRI.riSIPct,
                riPrem: CargoRiskRI.riPrem,
                riPremDisp: formatPrice(CargoRiskRI.riPrem),
                riComm1: CargoRiskRI.riComm1,
                riComm1Disp: formatPrice(CargoRiskRI.riComm1),
                riComm2: CargoRiskRI.riComm2,
                riComm2Disp: formatPrice(CargoRiskRI.riComm2),
                riComm3: CargoRiskRI.riComm3,
                riComm3Disp: formatPrice(CargoRiskRI.riComm3)
              }
              this.riskAccumCargoRiskRIItem.push(convertCargoRiskRI)
            })
            this.loading = false
          } else {
            this.loading = false
            this.riskAccumCargoRiskRIItem = []
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      }
    },
    async getPolHullRiskDet(accumDet) {
      const apiUrl = this.riskAccumulationList.getPolHullRiskDet
      const requestParams = {
        polNo: accumDet.polNo,
        renCnt: accumDet.renCnt,
        endtCnt: accumDet.endtCnt,
        riskGrpNo: accumDet.riskGrp,
        riskNo: accumDet.riskNo
      }
      if (apiUrl) {
        try {
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          const { data } = result.data
          if (data) {
            this.riskAccumDetailForm.vesNo = data.polHullRisk.vesNo
            this.riskAccumDetailForm.vesName = data.polHullRisk.vesName
            this.riskAccumDetailForm.vesDesc = data.polHullRisk.vesDesc
            this.riskAccumDetailForm.cvrTypeDesc = data.polHullRisk.issDate
            this.riskAccumDetailForm.intCvrd = data.polHullRisk.intCvrd
            this.riskAccumDetailForm.intCvrdDesc = data.polHullRisk.intCvrdDesc
            this.riskAccumDetailForm.imoRefNo = data.polHullRisk.imoRefNo
            this.riskAccumDetailForm.chartRefNo = data.polHullRisk.chartRefNo
            this.riskAccumDetailForm.mortgagee = data.polHullRisk.mortgagee
            this.riskAccumDetailForm.yrBuilt = data.polHullRisk.yrBuilt
            this.riskAccumDetailForm.vesFlag = data.polHullRisk.vesFlag
            this.riskAccumDetailForm.vesFlagDesc = data.polHullRisk.vesFlagDesc
            this.riskAccumDetailForm.vesCls = data.polHullRisk.vesCls
            this.riskAccumDetailForm.vesClsDesc = data.polHullRisk.vesClsDesc
            this.riskAccumDetailForm.vesType = data.polHullRisk.vesType
            this.riskAccumDetailForm.vesTypeDesc = data.polHullRisk.vesTypeDesc
            this.riskAccumDetailForm.grt = data.polHullRisk.grt
            this.riskAccumDetailForm.nrt = data.polHullRisk.nrt
            this.riskAccumDetailForm.dwt = data.polHullRisk.dwt
            this.riskAccumDetailForm.vesConstn = data.polHullRisk.vesConstn
            this.riskAccumDetailForm.vesOwn = data.polHullRisk.vesOwn
            this.riskAccumDetailForm.vesAgt = data.polHullRisk.vesAgt
            this.riskAccumDetailForm.vesAgtName = data.polHullRisk.vesAgtName
            this.riskAccumDetailForm.comDate = formatDisplayDate(data.polHullRisk.comDate)
            this.riskAccumDetailForm.expDate = formatDisplayDate(data.polHullRisk.expDate)
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      }
    },
    async getHullRiskRI(accumDet) {
      const apiUrl = this.riskAccumulationList.getHullRiskRI
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationHullRiskRI
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          const requestParams = {
            polNo: accumDet.polNo,
            renCnt: accumDet.renCnt,
            cesEndtCnt: accumDet.cesEndtCnt,
            riskGrpNo: accumDet.riskGrp,
            riskNo: accumDet.riskNo
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), requestParams, this.paginationHullRiskRI.sortBy, this.paginationHullRiskRI.descending))
          const { data } = result.data
          this.totalItemsRiskAccumHullRiskRI = data.totalElements
          this.riskAccumHullRiskRIItem = []
          if (data) {
            data.map(HullRiskRI => {
              const convertHullRiskRI = {
                riType: HullRiskRI.riType,
                riCo: HullRiskRI.riCo,
                acctNoSfx: HullRiskRI.acctNoSfx,
                comDate: formatDisplayDate(HullRiskRI.comDate),
                expDate: formatDisplayDate(HullRiskRI.expDate),
                riSI: this.riskAccumForm.currency === 'L' ? HullRiskRI.riSI * this.riskAccumDetailForm.siExRate : HullRiskRI.riSI,
                riSIDisp: formatPrice(this.riskAccumForm.currency === 'L' ? HullRiskRI.riSI * this.riskAccumDetailForm.siExRate : HullRiskRI.riSI),
                riSIPct: HullRiskRI.riSIPct,
                riPrem: HullRiskRI.riPrem,
                riPremDisp: formatPrice(HullRiskRI.riPrem),
                riComm1: HullRiskRI.riComm1,
                riComm1Disp: formatPrice(HullRiskRI.riComm1),
                riComm2: HullRiskRI.riComm2,
                riComm2Disp: formatPrice(HullRiskRI.riComm2),
                riComm3: HullRiskRI.riComm3,
                riComm3Disp: formatPrice(HullRiskRI.riComm3)
              }
              this.riskAccumHullRiskRIItem.push(convertHullRiskRI)
            })
            this.loading = false
          } else {
            this.loading = false
            this.riskAccumHullRiskRIItem = []
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      }
    },
    async getPolMotorRiskDet(accumDet) {
      const apiUrl = this.riskAccumulationList.getPolMotorRiskDet
      const requestParams = {
        polNo: accumDet.polNo,
        renCnt: accumDet.renCnt,
        endtCnt: accumDet.endtCnt,
        riskGrpNo: accumDet.riskGrp,
        riskNo: accumDet.riskNo
      }
      if (apiUrl) {
        try {
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          const { data } = result.data
          if (data) {
            this.riskAccumDetailForm.tarf = data.polMtrRisk.tarf
            this.riskAccumDetailForm.tarfDesc = data.polMtrRisk.tarfDesc
            this.riskAccumDetailForm.cvrType = data.polMtrRisk.cvrType
            this.riskAccumDetailForm.cvrTypeDesc = data.polMtrRisk.cvrTypeDesc
            this.riskAccumDetailForm.vehRegNo = data.polMtrRisk.vehRegNo
            this.riskAccumDetailForm.colour = data.polMtrRisk.colour
            this.riskAccumDetailForm.certRef = data.polMtrRisk.certRef
            this.riskAccumDetailForm.certRefDesc = data.polMtrRisk.certRefDesc
            this.riskAccumDetailForm.trailerRegNo = data.polMtrRisk.trailerRegNo
            this.riskAccumDetailForm.engNo = data.polMtrRisk.engNo
            this.riskAccumDetailForm.chasNo = data.polMtrRisk.chasNo
            this.riskAccumDetailForm.logBook = data.polMtrRisk.logBook
            this.riskAccumDetailForm.vehMake = data.polMtrRisk.vehMake
            this.riskAccumDetailForm.modelNo = data.polMtrRisk.modelNo
            this.riskAccumDetailForm.modelDesc = data.polMtrRisk.modelDesc
            this.riskAccumDetailForm.yrManuf = data.polMtrRisk.yrManuf
            this.riskAccumDetailForm.regYr = data.polMtrRisk.regYr
            this.riskAccumDetailForm.regMth = data.polMtrRisk.regMth
            this.riskAccumDetailForm.vehBody = data.polMtrRisk.vehBody
            this.riskAccumDetailForm.engCc = data.polMtrRisk.engCc
            this.riskAccumDetailForm.tonnage = data.polMtrRisk.tonnage
            this.riskAccumDetailForm.maxLaden = data.polMtrRisk.maxLaden
            this.riskAccumDetailForm.unLaden = data.polMtrRisk.unLaden
            this.riskAccumDetailForm.noSeats = data.polMtrRisk.noSeats
            this.riskAccumDetailForm.mileage = data.polMtrRisk.mileage
            this.riskAccumDetailForm.vehGrp = data.polMtrRisk.vehGrp
            this.riskAccumDetailForm.vehGrpDesc = data.polMtrRisk.vehGrpDesc
            this.riskAccumDetailForm.vehUse = data.polMtrRisk.vehUse
            this.riskAccumDetailForm.vehUseDesc = data.polMtrRisk.vehUseDesc
            this.riskAccumDetailForm.ownName = data.polMtrRisk.ownName
            this.riskAccumDetailForm.vehOwnIcNo = data.polMtrRisk.vehOwnIcno
            this.riskAccumDetailForm.insdVal = data.polMtrRisk.insdVal
            this.riskAccumDetailForm.hpOwn = data.polMtrRisk.hpOwn
            this.riskAccumDetailForm.ncbYr = data.polMtrRisk.ncbYr
            this.riskAccumDetailForm.ncbPct = data.polMtrRisk.ncbPct
            this.riskAccumDetailForm.retnNcd = data.polMtrRisk.retnNcd
            this.riskAccumDetailForm.ltaTranDate = data.polMtrRisk.ltaTranDate
            this.riskAccumDetailForm.upldDate = data.polMtrRisk.upldDate
            this.riskAccumDetailForm.comDate = formatDisplayDate(data.polMtrRisk.comDate)
            this.riskAccumDetailForm.expDate = formatDisplayDate(data.polMtrRisk.expDate)
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      }
    },
    async getMotorRiskRI(accumDet) {
      const apiUrl = this.riskAccumulationList.getMotorRiskRI
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationMotorRiskRI
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          const requestParams = {
            polNo: accumDet.polNo,
            renCnt: accumDet.renCnt,
            cesEndtCnt: accumDet.cesEndtCnt,
            riskGrpNo: accumDet.riskGrp,
            riskNo: accumDet.riskNo
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), requestParams, this.paginationMotorRiskRI.sortBy, this.paginationMotorRiskRI.descending))
          const { data } = result.data
          this.riskAccumMotorRiskRIItem = []
          if (data) {
            data.map(MotorRiskRI => {
              const convertMotorRiskRI = {
                riType: MotorRiskRI.riType,
                riCo: MotorRiskRI.riCo,
                acctNoSfx: MotorRiskRI.acctNoSfx,
                comDate: formatDisplayDate(MotorRiskRI.comDate),
                expDate: formatDisplayDate(MotorRiskRI.expDate),
                riSI: this.riskAccumForm.currency === 'L' ? MotorRiskRI.riSI * this.riskAccumDetailForm.siExRate : MotorRiskRI.riSI,
                riSIDisp: formatPrice(this.riskAccumForm.currency === 'L' ? MotorRiskRI.riSI * this.riskAccumDetailForm.siExRate : MotorRiskRI.riSI),
                riSIPct: MotorRiskRI.riSIPct,
                riPrem: MotorRiskRI.riPrem,
                riPremDisp: formatPrice(MotorRiskRI.riPrem),
                riComm1: MotorRiskRI.riComm1,
                riComm1Disp: formatPrice(MotorRiskRI.riComm1),
                riComm2: MotorRiskRI.riComm2,
                riComm2Disp: formatPrice(MotorRiskRI.riComm2),
                riComm3: MotorRiskRI.riComm3,
                riComm3Disp: formatPrice(MotorRiskRI.riComm3)
              }
              this.riskAccumMotorRiskRIItem.push(convertMotorRiskRI)
            })
            this.loading = false
          } else {
            this.loading = false
            this.riskAccumMotorRiskRIItem = []
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      }
    },
    async getPolMiscRiskDet(accumDet) {
      const apiUrl = this.riskAccumulationList.getPolMiscRiskDet
      const requestParams = {
        polNo: accumDet.polNo,
        renCnt: accumDet.renCnt,
        endtCnt: accumDet.endtCnt,
        riskGrpNo: accumDet.riskGrp,
        riskNo: accumDet.riskNo
      }
      if (apiUrl) {
        try {
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          const { data } = result.data
          if (data) {
            this.riskAccumDetailForm.contrt = data.polMiscRisk.contrt
            this.riskAccumDetailForm.comDate = formatDisplayDate(data.polMiscRisk.comDate)
            this.riskAccumDetailForm.expDate = formatDisplayDate(data.polMiscRisk.expDate)
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      }
    },
    async getMiscRiskRI(accumDet) {
      const apiUrl = this.riskAccumulationList.getMiscRiskRI
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationMotorRiskRI
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          const requestParams = {
            polNo: accumDet.polNo,
            renCnt: accumDet.renCnt,
            cesEndtCnt: accumDet.cesEndtCnt,
            riskGrpNo: accumDet.riskGrp,
            riskNo: accumDet.riskNo
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), requestParams, this.paginationMotorRiskRI.sortBy, this.paginationMotorRiskRI.descending))
          const { data } = result.data
          this.riskAccumMiscRiskRIItem = []
          if (data) {
            data.map(MotorRiskRI => {
              const convertMotorRiskRI = {
                riType: MotorRiskRI.riType,
                riCo: MotorRiskRI.riCo,
                acctNoSfx: MotorRiskRI.acctNoSfx,
                comDate: formatDisplayDate(MotorRiskRI.comDate),
                expDate: formatDisplayDate(MotorRiskRI.expDate),
                riSI: this.riskAccumForm.currency === 'L' ? MotorRiskRI.riSI * this.riskAccumDetailForm.siExRate : MotorRiskRI.riSI,
                riSIDisp: formatPrice(this.riskAccumForm.currency === 'L' ? MotorRiskRI.riSI * this.riskAccumDetailForm.siExRate : MotorRiskRI.riSI),
                riSIPct: MotorRiskRI.riSIPct,
                riPrem: MotorRiskRI.riPrem,
                riPremDisp: formatPrice(MotorRiskRI.riPrem),
                riComm1: MotorRiskRI.riComm1,
                riComm1Disp: formatPrice(MotorRiskRI.riComm1),
                riComm2: MotorRiskRI.riComm2,
                riComm2Disp: formatPrice(MotorRiskRI.riComm2),
                riComm3: MotorRiskRI.riComm3,
                riComm3Disp: formatPrice(MotorRiskRI.riComm3)
              }
              this.riskAccumMiscRiskRIItem.push(convertMotorRiskRI)
            })
            this.loading = false
          } else {
            this.loading = false
            this.riskAccumMiscRiskRIItem = []
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      }
    },
    async checkBlk(blk) {
      const apiUrl = this.riskAccumulationList.getBlk
      const requestParams = {
        accmType: this.riskAccumForm.accumType,
        blkGrp: blk.blkGrp,
        blksGrp1: blk.blksGrp1,
        blksGrp2: blk.blksGrp2,
        blk: blk.blk,
        effDate: new Date(this.riskAccumForm.effDate)
      }
      if (apiUrl) {
        try {
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          const { data } = result.data
          if (data) {
            this.riskAccumForm.blksLblS = data.blk.blk
            this.riskAccumForm.blksLblL = data.blk.blkDesc
            return true
          } else {
            return false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          return false
        }
      }
    },
    async doUpdTransfBlk() {
      const apiUrl = this.riskAccumulationList.updTransfBlk
      if (apiUrl) {
        try {
          const result = await this.$http.post(apiUrl, this.transferForm)
          if (result) {
            this.notify(result.data)
            if (result.data.messages[0].type === 'SUCCESS') {
              this.doCloseConfirmBlk()
              this.doClose()
              this.doAccumulation()
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          return false
        }
      }
    },
    async getExtraBlkPolRiskBlkList(accumDet) {
      const apiUrl = this.riskAccumulationList.getExtraBlkPolRiskBlkList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationExtraBlkPolRiskBlk
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          const requestParams = {
            polNo: this.riskAccumDetailForm.polNo,
            renCnt: this.riskAccumDetailForm.renCnt,
            endtCnt: this.riskAccumDetailForm.endtCnt,
            riskGrpNo: this.riskAccumDetailForm.riskGrp,
            riskNo: this.riskAccumDetailForm.riskNo,
            accmType: this.riskAccumDetailForm.accumType
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), requestParams, this.paginationExtraBlkPolRiskBlk.sortBy, this.paginationExtraBlkPolRiskBlk.descending))
          const { data } = result.data
          this.totalItemsExtraBlkPolRiskBlk = result.data.totalElements
          this.extraBlkPolRiskBlkItem = []
          if (data) {
            data.map(polRiskBlk => {
              const convertPolRiskBlk = {
                seqNo: polRiskBlk.seqNo,
                blkGrp: polRiskBlk.blkGrp,
                blkSGrp1: polRiskBlk.blksGrp1,
                blkSGrp2: polRiskBlk.blksGrp2,
                blk: polRiskBlk.blk,
                floatSiLim: polRiskBlk.floatSilim,
                floatSiLimDisp: formatPrice(polRiskBlk.floatSilim),
                floatPrem: polRiskBlk.floatPrem,
                floatPremDisp: formatPrice(polRiskBlk.floatPrem),
                delRisk: polRiskBlk.delRisk
              }
              this.extraBlkPolRiskBlkItem.push(convertPolRiskBlk)
            })
            this.loading = false
          } else {
            this.extraBlkPolRiskBlkItem = []
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          return false
        }
      }
    },
    async doFetchExtraBlk(polRiskBlk) {
      const apiUrl = this.riskAccumulationList.getExtraBlkDet
      if (apiUrl) {
        try {
          const expand = {
            polNo: polRiskBlk.polNo,
            renCnt: polRiskBlk.renCnt,
            endtCnt: polRiskBlk.endtCnt,
            riskGrpNo: polRiskBlk.riskGrpNo,
            riskNo: polRiskBlk.riskNo,
            seqNo: polRiskBlk.seqNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const data = result.data
          if (data) {
            this.extraBlkForm.floatSiLim = formatPrice(data.floatSilim)
            this.extraBlkForm.floatPrem = formatPrice(data.floatPrem)
            this.extraBlkForm.voyDate = data.voyDate
            this.extraBlkForm.voyDesc = data.voyDesc
            this.extraBlkForm.bldgNo = data.bldgNo
            this.extraBlkForm.unitNo = data.unitNo
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doCreateExtraBlk() {
      const apiUrl = this.riskAccumulationList.createExtraBlk
      if (apiUrl) {
        this.submittingExtraBlk = true
        try {
          this.extraBlkForm.floatSiLim = (this.extraBlkForm.floatSiLim)
          this.extraBlkForm.floatPrem = (this.extraBlkForm.floatPrem)
          const result = await this.$http.post(apiUrl, this.extraBlkForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.showExtraBlkDet = false
            this.getExtraBlkPolRiskBlkList(this.riskAccumDetailForm)
          }
          this.submittingExtraBlk = false
        } catch (err) {
          this.submittingExtraBlk = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdateExtraBlk() {
      const apiUrl = this.riskAccumulationList.updateExtraBlk
      if (apiUrl) {
        this.submittingExtraBlk = true
        try {
          this.extraBlkForm.floatSiLim = this.extraBlkForm.floatSiLim !== null ? removeFormatNumber(this.extraBlkForm.floatSiLim) : 0
          this.extraBlkForm.floatPrem = this.extraBlkForm.floatPrem !== null ? removeFormatNumber(this.extraBlkForm.floatPrem) : 0
          const result = await this.$http.put(apiUrl, this.extraBlkForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.showExtraBlkDet = false
            this.getExtraBlkPolRiskBlkList(this.riskAccumDetailForm)
          }
          this.submittingExtraBlk = false
        } catch (err) {
          this.submittingExtraBlk = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doRemoveExtraBlk(polRiskBlk) {
      // polRiskBlk.delRisk = true
      const apiUrl = this.riskAccumulationList.deleteExtraBlk
      if (apiUrl) {
        try {
          const expand = {
            polNo: this.extraBlkForm.polNo,
            renCnt: this.extraBlkForm.renCnt,
            endtCnt: this.extraBlkForm.endtCnt,
            riskGrpNo: this.extraBlkForm.riskGrpNo,
            riskNo: this.extraBlkForm.riskNo,
            accmType: this.extraBlkForm.accmType,
            seqNo: polRiskBlk.seqNo,
            blkGrpLblS: polRiskBlk.blkGrp,
            blksGrp1LblSL: polRiskBlk.blkSGrp1,
            blksGrp2LblSL: polRiskBlk.blkSGrp2,
            blksLblS: polRiskBlk.blk
          }
          this.$http.post(apiUrl, expand).then(result => {
            const data = result.data
            this.notify(data)
            this.showExtraBlkDet = false
            this.getExtraBlkPolRiskBlkList(this.riskAccumDetailForm)
          }).catch(err => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doConfirmBlkProcedure() {
      const apiUrl = this.riskAccumulationList.confirmBlkProcedure
      if (apiUrl) {
        try {
          const result = await this.$http.put(apiUrl, this.confirmBlkForm)
          if (result) {
            this.notify(result.data)
            if (result.data.messages[0].type === 'SUCCESS') {
              this.doCloseConfirmBlk()
              this.doClose()
              this.doAccumulation()
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          return false
        }
      }
    },
    async doLoadingPctProcedure() {
      const apiUrl = this.riskAccumulationList.loadingPctProcedure
      if (apiUrl) {
        try {
          const result = await this.$http.put(apiUrl, this.loadingPctForm)
          if (result) {
            this.notify(result.data)
            if (result.data.messages[0].type === 'SUCCESS') {
              this.doCloseLoadingPct()
              this.doClose()
              return true
            } else {
              return false
            }
          } else {
            return false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          return false
        }
      }
    },
    async checkLoadingPct(loadingForm) {
      const apiUrl = this.riskAccumulationList.checkLoadingPct
      const requestParams = {
        polNo: loadingForm.polNo,
        renCnt: loadingForm.renCnt,
        endtCnt: loadingForm.endtCnt,
        riskGrpNo: loadingForm.riskGrpNo,
        riskNo: loadingForm.riskNo,
        blkGrpLblS: loadingForm.blkGrpLblS,
        blksGrp1LblS: loadingForm.blksGrp1LblS,
        blksGrp2LblS: loadingForm.blksGrp2LblS,
        blksLblS: loadingForm.blksLblS
      }
      if (apiUrl) {
        try {
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          if (result) {
            this.loadingPctForm.accmLdgPct = result.data.accmLdgPct
            this.notify(result.data)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          return false
        }
      }
    },
    async getBlkTtyLimRtnLim() {
      const apiUrl = this.riskAccumulationList.getBlkTtyLimRtnLim
      if (apiUrl) {
        try {
          const requestParams = {
            accmType: this.riskAccumForm.accumType,
            blkGrp: this.riskAccumForm.blkGrpLblS,
            blkS1Grp: this.riskAccumForm.blksGrp1LblS,
            blkS2Grp: this.riskAccumForm.blksGrp2LblS,
            blk: this.riskAccumForm.blksLblS
          }
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          if (result.data) {
            this.riskAccumForm.rtnLimKey = formatPrice(result.data.data.ownRtn)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          return false
        }
      }
    },
    async getRiskAccumulationList2() {
      const apiUrl = this.riskAccumulationList.getRiskAccumLists2
      if (apiUrl) {
        try {
          this.loading = true
          this.riskAccumDetailItems = []
          const { page, itemsPerPage } = this.paginationAccumList2
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          const requestParams = {
            accmType: this.riskAccumForm.accumType,
            blkGrpLblS: this.riskAccumForm.blkGrpLblS,
            blksGrp1LblS: this.riskAccumForm.blksGrp1LblS,
            blksGrp2LblS: this.riskAccumForm.blksGrp2LblS,
            blksLblS: this.riskAccumForm.blksLblS,
            currency: this.riskAccumForm.currency,
            accumBlkLbl: this.riskAccumForm.accumBlkLbl,
            rtnLimKey: this.riskAccumForm.rtnLimKey,
            filterBy: this.riskAccumForm.filterBy,
            asAtDate: formatDisplayDate(this.riskAccumForm.asAtDate)
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), requestParams, this.paginationAccumList2.sortBy, this.paginationAccumList2.sortDesc))
          if (result.data) {
            this.totalItemsRiskAccumDetail = result.data.totalElements
            const { data } = result.data
            if (data) {
              let curr = this.riskAccumForm.currency
              let accumBase = this.riskAccumForm.accumBase
              data.map(polRiskBlk => {
                let sumInsdDisp = polRiskBlk.si
                let coinSumInsdDisp = polRiskBlk.coInsSi
                let statSumInsdDisp = polRiskBlk.statSi
                let grossRetDisp = polRiskBlk.grossRet
                let qShareSumInsdDisp = polRiskBlk.qShareSi
                let netRetDisp = polRiskBlk.netRet
                let treatySumInsdDisp = polRiskBlk.treatySi
                let facSumInsdDisp = polRiskBlk.facSi

                if (curr === 'L') {
                  sumInsdDisp = polRiskBlk.siLoc
                  coinSumInsdDisp = polRiskBlk.coInsLoc
                  statSumInsdDisp = polRiskBlk.statLoc
                  grossRetDisp = polRiskBlk.grossRetLoc
                  qShareSumInsdDisp = polRiskBlk.qShareLoc
                  netRetDisp = polRiskBlk.netRetLoc
                  treatySumInsdDisp = polRiskBlk.treatyLoc
                  facSumInsdDisp = polRiskBlk.facLoc
                }

                let emlPct = polRiskBlk.emlPct
                if (accumBase === 'EML') {
                  sumInsdDisp = (sumInsdDisp * emlPct) / 100
                  coinSumInsdDisp = (coinSumInsdDisp * emlPct) / 100
                  statSumInsdDisp = (statSumInsdDisp * emlPct) / 100
                  grossRetDisp = (grossRetDisp * emlPct) / 100
                  qShareSumInsdDisp = (qShareSumInsdDisp * emlPct) / 100
                  netRetDisp = (netRetDisp * emlPct) / 100
                  treatySumInsdDisp = (treatySumInsdDisp * emlPct) / 100
                  facSumInsdDisp = (facSumInsdDisp * emlPct) / 100
                }
                const convertBlkGrp = {
                  polNo: polRiskBlk.polNo,
                  renCnt: polRiskBlk.renCnt,
                  endtCnt: polRiskBlk.endtCnt,
                  riskGrp: polRiskBlk.riskGrpNo,
                  riskNo: polRiskBlk.riskNo,
                  seqNo: polRiskBlk.seqNo,
                  accumType: polRiskBlk.accmType,
                  blkGrp: polRiskBlk.blkGrp,
                  blksGrp1: polRiskBlk.blksGrp1,
                  blksGrp2: polRiskBlk.blksGrp2,
                  blk: polRiskBlk.blk,
                  insdName1: polRiskBlk.insdName1,
                  busClsAppId: polRiskBlk.busClsAppId,
                  busCls: polRiskBlk.busCls,
                  busClsDesc: polRiskBlk.busClsDesc,
                  comDate: formatDisplayDate(polRiskBlk.comDate),
                  expDate: formatDisplayDate(polRiskBlk.expDate),
                  currency: this.riskAccumForm.currency === 'L' ? polRiskBlk.siCurrLoc : polRiskBlk.siCurr,
                  currencyOri: polRiskBlk.siCurr,
                  currDesc: this.riskAccumForm.currency === 'L' ? polRiskBlk.currDescLoc : polRiskBlk.currDesc,
                  siExRate: polRiskBlk.siExRate,
                  billCurr: polRiskBlk.billCurr,
                  billCurrDesc: polRiskBlk.billCurrDesc,
                  billCurrRate: polRiskBlk.billCurrRate,
                  totalSi: polRiskBlk.ttSi,
                  totalSiDisp: formatPrice(polRiskBlk.ttSi),
                  sumInsd: polRiskBlk.si,
                  sumInsdDisp: formatPrice(sumInsdDisp),
                  premDue: polRiskBlk.premDue,
                  premDueDisp: formatPrice(polRiskBlk.premDue),
                  iCount: polRiskBlk.iCount,
                  ttyNo1: this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc1 : polRiskBlk.ttySI1,
                  ttyNo1Disp: formatPrice(this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc1 : polRiskBlk.ttySI1),
                  ttyNo2: this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc2 : polRiskBlk.ttySI2,
                  ttyNo2Disp: formatPrice(this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc2 : polRiskBlk.ttySI2),
                  ttyNo3: this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc3 : polRiskBlk.ttySI3,
                  ttyNo3Disp: formatPrice(this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc3 : polRiskBlk.ttySI3),
                  ttyNo4: this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc4 : polRiskBlk.ttySI4,
                  ttyNo4Disp: formatPrice(this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc4 : polRiskBlk.ttySI4),
                  ttyNo5: this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc5 : polRiskBlk.ttySI5,
                  ttyNo5Disp: formatPrice(this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc5 : polRiskBlk.ttySI5),
                  ttyNo6: this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc6 : polRiskBlk.ttySI6,
                  ttyNo6Disp: formatPrice(this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc6 : polRiskBlk.ttySI6),
                  ttyNo7: this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc7 : polRiskBlk.ttySI7,
                  ttyNo7Disp: formatPrice(this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc7 : polRiskBlk.ttySI7),
                  ttyNo8: this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc8 : polRiskBlk.ttySI8,
                  ttyNo8Disp: formatPrice(this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc8 : polRiskBlk.ttySI8),
                  ttyNo9: this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc9 : polRiskBlk.ttySI9,
                  ttyNo9Disp: formatPrice(this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc9 : polRiskBlk.ttySI9),
                  ttyNo10: this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc10 : polRiskBlk.ttySI10,
                  ttyNo10Disp: formatPrice(this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc10 : polRiskBlk.ttySI10),
                  coinSumInsd: polRiskBlk.coInsSi,
                  coinSumInsdDisp: formatPrice(coinSumInsdDisp),
                  coinPct: polRiskBlk.coInsPct,
                  statSumInsd: polRiskBlk.statSi,
                  statSumInsdDisp: formatPrice(statSumInsdDisp),
                  statPct: polRiskBlk.statPct,
                  facSumInsd: polRiskBlk.facSi,
                  facSumInsdDisp: formatPrice(facSumInsdDisp),
                  facPct: polRiskBlk.facPct,
                  treatySumInsd: polRiskBlk.treatySi,
                  treatySumInsdDisp: formatPrice(treatySumInsdDisp),
                  treatyPct: polRiskBlk.treatyPct,
                  grossRet: polRiskBlk.grossRet,
                  grossRetDisp: formatPrice(grossRetDisp),
                  grossPct: polRiskBlk.grossRetPct,
                  qShareSumInsd: polRiskBlk.qShareSi,
                  qShareSumInsdDisp: formatPrice(qShareSumInsdDisp),
                  qSharePct: polRiskBlk.qSharePct,
                  netRet: polRiskBlk.netRet,
                  netRetDisp: formatPrice(netRetDisp),
                  netPct: polRiskBlk.netRetPct,
                  delRisk: polRiskBlk.delRisk,
                  cfmRisk: polRiskBlk.cfmRisk,
                  cfmRiskDisp: formatYesNo(polRiskBlk.cfmRisk),
                  bldgNo: polRiskBlk.bldgNo,
                  unitNo: polRiskBlk.unitNo,
                  emlPct: polRiskBlk.emlPct
                }
                this.riskAccumDetailItems.push(convertBlkGrp)
              })
            }
          }
          this.loading = false
          this.processLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
          this.processLoading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async getRiskAccumulationList() {
      const apiUrl = this.riskAccumulationList.getRiskAccumLists
      const params = {
        accmType: this.riskAccumForm.accumType,
        blkGrpLblS: this.riskAccumForm.blkGrpLblS,
        blksGrp1LblS: this.riskAccumForm.blksGrp1LblS,
        blksGrp2LblS: this.riskAccumForm.blksGrp2LblS,
        blksLblS: this.riskAccumForm.blksLblS,
        currency: this.riskAccumForm.currency,
        accumBlkLbl: this.riskAccumForm.accumBlkLbl,
        rtnLimKey: this.riskAccumForm.rtnLimKey,
        filterBy: this.riskAccumForm.filterBy,
        asAtDate: formatDisplayDate(this.riskAccumForm.asAtDate)
      }
      if (apiUrl) {
        try {
          this.loading = true
          const result = await this.$http.get(expandURI(apiUrl, params))
          const data = result.data
          this.riskAccumulationDto = data
          this.processAccumList(data)
          this.processAcummTotals(data)
          this.processTreatyTotals(data)
          this.processLoading = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
          this.treatyTotalItems = []
          this.riskAccumDetailItemsTotal = []
          this.loading = false
          this.treatyItemList = false
          this.processLoading = false
        }
      }
    },
    processTreatyTotals(data) {
      this.treatyTotalItems = []
      this.doResetRiskAccumColumn()
      if (data) {
        let cTtyRet = data.cTtyRet
        this.ccTtyRet = cTtyRet
        let local = this.riskAccumForm.currency === 'L'
        this.totalTreatyTotal = data.ttTreatyTotals.length
        if (this.totalTreatyTotal > 0) {
          this.treatyItemList = true
        }
        let netRetention = 0
        let netRetentionLoc = 0
        data.ttPolBlocks.forEach(function (obj) {
          netRetention = netRetentionLoc + obj.netRetLoc
          netRetentionLoc = netRetentionLoc + obj.netRetLoc
        })

        data.ttTreatyTotals.map(treatyTotalList => {
          let ttyTotal = treatyTotalList.ttyTotal
          let ttyTotalOri = treatyTotalList.ttyTotalOri
          if (cTtyRet !== '' && cTtyRet === treatyTotalList.ttyNo) {
            if (local) {
              ttyTotal = ttyTotal + netRetentionLoc
            } else {
              ttyTotal = ttyTotal + netRetention
            }
          }
          const convertTreatyTotalList = {
            ttyNo: treatyTotalList.ttyNo,
            ttyLim: treatyTotalList.ttyLim,
            riType: treatyTotalList.riType,
            ttyLimDisp: formatPrice(treatyTotalList.ttyLim),
            treatyTotal: ttyTotal,
            treatyTotalOri: ttyTotalOri,
            treatyTotalDisp: formatPrice(ttyTotal),
            bal: (treatyTotalList.ttyLim - ttyTotal),
            balDisp: formatPrice(treatyTotalList.ttyLim - ttyTotal)
          }
          this.treatyTotalItems.push(convertTreatyTotalList)
        })
        this.addHeader(this.treatyTotalItems)
        this.loading = false
        this.processLoading = false
      } else {
        this.treatyTotalItems = []
        this.loading = false
        this.treatyItemList = false
        this.processLoading = false
      }
    },
    processAcummTotals(data) {
      this.riskAccumDetailItemsTotal = []
      if (data) {
        data.ttPolBlocks.map(accumListTotal => {
          const convertAccumListTotal = {
            sumInsd: accumListTotal.si,
            sumInsdLoc: accumListTotal.siLoc,
            sumInsdDisp: formatPrice(accumListTotal.riSi),
            coinSumInsd: accumListTotal.coInsSi,
            coinSumInsdLoc: accumListTotal.coInsLoc,
            coinSumInsdDisp: formatPrice(accumListTotal.coInsSi),
            coinPct: accumListTotal.coInsPct,
            statSumInsd: accumListTotal.statSi,
            statSumInsdLoc: accumListTotal.statLoc,
            statSumInsdDisp: formatPrice(accumListTotal.statSi),
            statPct: accumListTotal.statPct,
            facSumInsd: accumListTotal.facSi,
            facSumInsdLoc: accumListTotal.facLoc,
            facSumInsdDisp: formatPrice(accumListTotal.facSi),
            facPct: accumListTotal.facPct,
            treatySumInsd: accumListTotal.treatySi,
            treatySumInsdLoc: accumListTotal.treatyLoc,
            treatySumInsdDisp: formatPrice(accumListTotal.treatySi),
            treatyPct: accumListTotal.treatyPct,
            grossRet: accumListTotal.grossRet,
            grossRetLoc: accumListTotal.grossRetLoc,
            grossRetDisp: formatPrice(accumListTotal.grossRet),
            grossPct: accumListTotal.grossRetPct,
            qShareSumInsd: accumListTotal.qShareSi,
            qShareSumInsdLoc: accumListTotal.qShareLoc,
            qShareSumInsdDisp: formatPrice(accumListTotal.qShareSi),
            qSharePct: accumListTotal.qSharePct,
            netRet: accumListTotal.netRet,
            netRetLoc: accumListTotal.netRetLoc,
            netRetDisp: formatPrice(accumListTotal.netRet),
            netPct: accumListTotal.netRetPct
          }
          this.loading = false
          this.riskAccumDetailItemsTotal.push(convertAccumListTotal)
        })
        this.processLoading = false
      } else {
        this.processLoading = false
        this.riskAccumDetailItemsTotal = []
        this.loading = false
      }
    },
    processAccumList(data) {
      this.riskAccumDetailItems = []
      if (data) {
        let curr = this.riskAccumForm.currency
        let accumBase = this.riskAccumForm.accumBase
        data.ttPolBlocks.map(polRiskBlk => {
          let sumInsdDisp = polRiskBlk.si
          let coinSumInsdDisp = polRiskBlk.coInsSi
          let statSumInsdDisp = polRiskBlk.statSi
          let grossRetDisp = polRiskBlk.grossRet
          let qShareSumInsdDisp = polRiskBlk.qShareSi
          let netRetDisp = polRiskBlk.netRet
          let treatySumInsdDisp = polRiskBlk.treatySi
          let facSumInsdDisp = polRiskBlk.facSi

          if (curr === 'L') {
            sumInsdDisp = polRiskBlk.siLoc
            coinSumInsdDisp = polRiskBlk.coInsLoc
            statSumInsdDisp = polRiskBlk.statLoc
            grossRetDisp = polRiskBlk.grossRetLoc
            qShareSumInsdDisp = polRiskBlk.qShareLoc
            netRetDisp = polRiskBlk.netRetLoc
            treatySumInsdDisp = polRiskBlk.treatyLoc
            facSumInsdDisp = polRiskBlk.facLoc
          }

          let emlPct = polRiskBlk.emlPct
          if (accumBase === 'EML') {
            sumInsdDisp = (sumInsdDisp * emlPct) / 100
            coinSumInsdDisp = (coinSumInsdDisp * emlPct) / 100
            statSumInsdDisp = (statSumInsdDisp * emlPct) / 100
            grossRetDisp = (grossRetDisp * emlPct) / 100
            qShareSumInsdDisp = (qShareSumInsdDisp * emlPct) / 100
            netRetDisp = (netRetDisp * emlPct) / 100
            treatySumInsdDisp = (treatySumInsdDisp * emlPct) / 100
            facSumInsdDisp = (facSumInsdDisp * emlPct) / 100
          }

          const convertBlkGrp = {
            polNo: polRiskBlk.polNo,
            renCnt: polRiskBlk.renCnt,
            endtCnt: polRiskBlk.endtCnt,
            riskGrp: polRiskBlk.riskGrpNo,
            riskNo: polRiskBlk.riskNo,
            seqNo: polRiskBlk.seqNo,
            accumType: polRiskBlk.accmType,
            blkGrp: polRiskBlk.blkGrp,
            blksGrp1: polRiskBlk.blksGrp1,
            blksGrp2: polRiskBlk.blksGrp2,
            blk: polRiskBlk.blk,
            insdName1: polRiskBlk.insdName1,
            busClsAppId: polRiskBlk.busClsAppId,
            busCls: polRiskBlk.busCls,
            busClsDesc: polRiskBlk.busClsDesc,
            comDate: formatDisplayDate(polRiskBlk.comDate),
            expDate: formatDisplayDate(polRiskBlk.expDate),
            currency: this.riskAccumForm.currency === 'L' ? polRiskBlk.siCurrLoc : polRiskBlk.siCurr,
            currencyOri: polRiskBlk.siCurr,
            currDesc: this.riskAccumForm.currency === 'L' ? polRiskBlk.currDescLoc : polRiskBlk.currDesc,
            siExRate: polRiskBlk.siExRate,
            billCurr: polRiskBlk.billCurr,
            billCurrDesc: polRiskBlk.billCurrDesc,
            billCurrRate: polRiskBlk.billCurrRate,
            totalSi: polRiskBlk.ttSi,
            totalSiDisp: formatPrice(polRiskBlk.ttSi),
            sumInsd: polRiskBlk.si,
            sumInsdDisp: formatPrice(sumInsdDisp),
            premDue: polRiskBlk.premDue,
            premDueDisp: formatPrice(polRiskBlk.premDue),
            iCount: polRiskBlk.iCount,
            ttyNo1: this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc1 : polRiskBlk.ttySI1,
            ttyNo1Disp: formatPrice(this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc1 : polRiskBlk.ttySI1),
            ttyNo2: this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc2 : polRiskBlk.ttySI2,
            ttyNo2Disp: formatPrice(this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc2 : polRiskBlk.ttySI2),
            ttyNo3: this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc3 : polRiskBlk.ttySI3,
            ttyNo3Disp: formatPrice(this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc3 : polRiskBlk.ttySI3),
            ttyNo4: this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc4 : polRiskBlk.ttySI4,
            ttyNo4Disp: formatPrice(this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc4 : polRiskBlk.ttySI4),
            ttyNo5: this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc5 : polRiskBlk.ttySI5,
            ttyNo5Disp: formatPrice(this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc5 : polRiskBlk.ttySI5),
            ttyNo6: this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc6 : polRiskBlk.ttySI6,
            ttyNo6Disp: formatPrice(this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc6 : polRiskBlk.ttySI6),
            ttyNo7: this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc7 : polRiskBlk.ttySI7,
            ttyNo7Disp: formatPrice(this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc7 : polRiskBlk.ttySI7),
            ttyNo8: this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc8 : polRiskBlk.ttySI8,
            ttyNo8Disp: formatPrice(this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc8 : polRiskBlk.ttySI8),
            ttyNo9: this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc9 : polRiskBlk.ttySI9,
            ttyNo9Disp: formatPrice(this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc9 : polRiskBlk.ttySI9),
            ttyNo10: this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc10 : polRiskBlk.ttySI10,
            ttyNo10Disp: formatPrice(this.riskAccumForm.currency === 'L' ? polRiskBlk.ttySILoc10 : polRiskBlk.ttySI10),
            coinSumInsd: polRiskBlk.coInsSi,
            coinSumInsdDisp: formatPrice(coinSumInsdDisp),
            coinPct: polRiskBlk.coInsPct,
            statSumInsd: polRiskBlk.statSi,
            statSumInsdDisp: formatPrice(statSumInsdDisp),
            statPct: polRiskBlk.statPct,
            facSumInsd: polRiskBlk.facSi,
            facSumInsdDisp: formatPrice(facSumInsdDisp),
            facPct: polRiskBlk.facPct,
            treatySumInsd: polRiskBlk.treatySi,
            treatySumInsdDisp: formatPrice(treatySumInsdDisp),
            treatyPct: polRiskBlk.treatyPct,
            grossRet: polRiskBlk.grossRet,
            grossRetDisp: formatPrice(grossRetDisp),
            grossPct: polRiskBlk.grossRetPct,
            qShareSumInsd: polRiskBlk.qShareSi,
            qShareSumInsdDisp: formatPrice(qShareSumInsdDisp),
            qSharePct: polRiskBlk.qSharePct,
            netRet: polRiskBlk.netRet,
            netRetDisp: formatPrice(netRetDisp),
            netPct: polRiskBlk.netRetPct,
            delRisk: polRiskBlk.delRisk,
            cfmRisk: polRiskBlk.cfmRisk,
            cfmRiskDisp: formatYesNo(polRiskBlk.cfmRisk),
            bldgNo: polRiskBlk.bldgNo,
            unitNo: polRiskBlk.unitNo,
            emlPct: polRiskBlk.emlPct
          }
          this.riskAccumDetailItems.push(convertBlkGrp)
          // this.riskAccumForm.rtnLimKey = polRiskBlk.rtnLim
        })
        this.loading = false
      } else {
        this.riskAccumDetailItems = []
        this.processLoading = false
        this.loading = false
      }
    },
    removeFormatNumber(value) {
      return removeFormatNumber(value)
    },
    doResetRiskAccumColumn() {
      this.riskAccumDetailColumns = [
        { text: 'Policy No', value: 'polNo', width: '120px' },
        { text: 'Ren', value: 'renCnt', width: '75px' },
        { text: 'Endt', value: 'endtCnt', width: '75px' },
        { text: 'Insured Name', value: 'insdName1', width: '250px' },
        // 210901 SSY: New Columns in risk accumulation listing(Fire Accumulation only)
        // Start
        { text: 'Risk No', value: 'riskNo', width: '100px' },
        { text: 'Class', value: 'busCls', width: '100px' },
        { text: 'Confirm', value: 'cfmRisk', width: '100px' },
        { text: 'Confirm', value: 'cfmRiskDisp', width: '100px' },
        { text: 'Bldg', value: 'bldgNo', width: '300px' },
        { text: 'Unit', value: 'unitNo', width: '75px' },
        // End
        { text: 'Currency', value: 'currency', width: '120px' },
        { text: 'Sum', value: 'sumInsdDisp', width: '75px' },
        { text: 'Coins Sum', value: 'coinSumInsdDisp', width: '150px' },
        { text: 'Coins %', value: 'coinPct', width: '100px' },
        { text: 'Stat Sum', value: 'statSumInsdDisp', width: '100px' },
        { text: 'Stat %', value: 'statPct', width: '100px' },
        { text: 'Fac Sum', value: 'facSumInsdDisp', width: '100px' },
        { text: 'Fac %', value: 'facPct', width: '100px' },
        { text: 'Treaty Sum', value: 'treatySumInsdDisp', width: '150px' },
        { text: 'Treaty %', value: 'treatyPct', width: '100px' },
        { text: 'Gross', value: 'grossRetDisp', width: '100px' },
        { text: 'Gross %', value: 'grossPct', width: '100px' },
        { text: 'QShare Sum', value: 'qShareSumInsdDisp', width: '150px' },
        { text: 'QShare %', value: 'qSharePct', width: '120px' },
        { text: 'Net', value: 'netRetDisp', width: '100px' },
        { text: 'Net %', value: 'netPct', width: '100px' },
        { text: 'Com Date', value: 'comDate', width: '120px' },
        { text: 'Exp Date', value: 'expDate', width: '120px' }
      ]
    }
  },
  mixins: [
    MessageMixin
  ]
}
